import type { MessageKey } from './index';

// Romanian translations. Keys mirror ./index; TypeScript enforces completeness.
export const ro: Record<MessageKey, string> = {
  'common.cancel': 'Anulează',
  'common.stepperHint': 'Click pentru un pas (Shift ×10). Ține apăsat și trage în sus sau în jos',
  'common.confirm': 'Confirmă',
  'common.copied': 'Copiat',
  'common.create': 'Creează',
  'common.delete': 'Șterge',
  'renders.deleteSelected': 'Șterge selectate ({n})',
  'renders.deleteAll': 'Șterge tot',
  'renders.selectAll': 'Selectează tot',
  'renders.deleteTitle': 'Ștergi această generare?',
  'renders.deleteSelectedTitle': 'Ștergi generările selectate ({n})?',
  'renders.deleteAllTitle': 'Ștergi toate generările?',
  'renders.deleteFilteredTitle': 'Ștergi toate generările care corespund filtrelor?',
  'renders.deleteText':
    'Fișierele se șterg definitiv. Generările deja folosite din plan nu se returnează.',
  'renders.deleted': 'Șterse: {n}',
  'renders.skippedRunning': 'Încă în lucru, neșterse: {n}',
  'batch.delete': 'Șterge rularea',
  'batch.deleteTitle': 'Ștergi rularea și toate generările ei?',
  'batch.deleteText':
    'Se șterg toate imaginile rulării și arhiva ZIP. Generările deja folosite din plan nu se returnează.',
  'automation.deleteWithRenders': 'Șterge și toate bannerele generate',
  'err.batchRunning': 'Rularea este încă în curs — șterge-o după ce se termină.',
  'err.renderRunning': 'Generarea este încă în curs — șterge-o după ce se termină.',
  'audit.renders.deleted': 'Generări șterse:',
  'common.download': 'Descarcă',
  'common.edit': 'Editează',
  'common.error': 'Eroare',
  'common.height': 'Înălțime',
  'common.width': 'Lățime',
  'common.import': 'Importă',
  'nav.admin': 'Administrare',
  'billing.testMode': 'Mod de test superadmin',
  'billing.testModeHint':
    'Schimbă instantaneu planul acestui spațiu de lucru, fără plată — pentru a verifica limitele.',
  'billing.manual': 'manual',
  'admin.title': 'Administrare',
  'admin.description':
    'Toți utilizatorii și spațiile de lucru de pe platformă. Vizibil doar pentru superadmini.',
  'admin.overview': 'Prezentare generală',
  'admin.users': 'Utilizatori',
  'admin.usersHint': '+{n7} în 7 zile · +{n30} în 30 de zile',
  'admin.active7': 'Autentificați, 7 zile',
  'admin.blockedN': 'Blocați: {n}',
  'admin.renders30': 'Generări, 30 de zile',
  'admin.rendersHint': 'Azi {today} · eșuate {failed}',
  'admin.mrr': 'MRR (abonamente)',
  'admin.paying': 'Spații de lucru plătitoare: {n}',
  'admin.workspacesByPlan': 'Spații de lucru după plan · {n}',
  'admin.ai30': 'AI, 30 de zile',
  'admin.aiRequests': 'solicitări',
  'admin.aiCost': 'cost model',
  'admin.search': 'Caută după email sau nume',
  'admin.user': 'Utilizator',
  'admin.workspaces': 'Spații de lucru',
  'admin.workspace': 'Spațiu de lucru',
  'admin.signedUp': 'Înregistrat',
  'admin.lastLogin': 'Ultima autentificare',
  'admin.sessions': 'sesiuni active: {n}',
  'admin.blocked': 'blocat',
  'admin.block': 'Blochează',
  'admin.unblock': 'Deblochează',
  'admin.blockTitle': 'Blochezi {email}?',
  'admin.blockText':
    'Utilizatorul este deconectat peste tot și nu se poate autentifica până la deblocare. Spațiile de lucru și cheile API ale acestuia continuă să funcționeze.',
  'admin.blockedDone': 'Utilizator blocat',
  'admin.unblockedDone': 'Utilizator deblocat',
  'admin.signOut': 'Deconectează peste tot',
  'admin.signedOutDone': 'Sesiuni încheiate',
  'admin.delete': 'Șterge',
  'admin.deleteTitle': 'Ștergi {email}?',
  'admin.deleteText':
    'Contul este șters definitiv, împreună cu spațiile în care este singurul membru: șabloane, fișiere, randări. Refuzat dacă deține un spațiu comun sau are un abonament plătit.',
  'admin.deletedDone': 'Utilizator șters',
  'admin.plan': 'Plan',
  'admin.planSet': '„{name}” are acum planul {plan}',
  'admin.manual': 'manual',
  'admin.templates': 'Șabloane',
  'admin.renders30short': 'Generări 30 z',
  'admin.storage': 'Stocare',
  'admin.lastRender': 'Ultima generare',
  'admin.members': 'membri: {n}',
  'common.back': 'Înapoi',
  'common.next': 'Înainte',
  'legal.privacy': 'Politica de confidențialitate',
  'legal.terms': 'Termeni și condiții',
  'legal.privacyLower': 'politica de confidențialitate',
  'legal.termsLower': 'termenii și condițiile',
  'legal.and': 'și',
  'legal.consentPrefix': 'Prin înregistrare, ești de acord cu',
  'legal.updated': 'Ultima actualizare: {date}',
  'legal.home': 'Înapoi la pagina principală',
  'help.title': 'Ajutor și informații legale',
  'help.support': 'Asistență',
  'help.apiDocs': 'Documentație API',
  'help.apiDocsHint': 'Endpointuri, parametri, exemple',
  'help.termsHint': 'Regulile de utilizare a serviciului',
  'help.privacyHint': 'Ce date păstrăm și de ce',
  'preview.final': 'Generare finală fără filigran',
  'preview.watermarkHint': 'Gratuit: previzualizarea cu filigran nu consumă din plan.',
  'preview.finalHint': 'Consumă 1 generare din planul tău.',
  'billing.fPreviews': 'Previzualizări gratuite cu filigran',
  'showcase.badge': 'Editor',
  'showcase.title': 'Un editor care păstrează aspectul în formă',
  'showcase.subtitle':
    'Nu doar o pânză cu coordonate: stive ca în Figma, redimensionare inteligentă la orice format și spațiere precisă. Schimbă dimensiunea — aceasta este o generare reală.',
  'showcase.render': 'Generează',
  'showcase.layers': 'Straturi',
  'showcase.clickHint': 'Dă click pe un strat sau schimbă dimensiunea',
  'showcase.layer': 'Strat',
  'showcase.apiField': 'Numele stratului = câmp API și coloană din tabel',
  'showcase.stack': 'Stivă (auto layout)',
  'showcase.resize': 'Redimensionare',
  'showcase.resizeText':
    'Straturile se adaptează după regulile lor — un singur șablon pentru toate platformele.',
  'showcase.altHint': 'Alt — distanțe până la vecini',
  'showcase.p1Title': 'Stive ca în Figma',
  'showcase.p1Text': 'Un text lung din API împinge vecinii în loc să se suprapună peste ei.',
  'showcase.p2Title': 'Un șablon, toate dimensiunile',
  'showcase.p2Text': 'Postare, story și banner dintr-un singur design, cu straturile adaptate.',
  'showcase.p3Title': 'Spațiere precisă',
  'showcase.p3Text': 'Aliniere automată, ghidaje și distanțe până la vecini cu Alt.',
  'showcase.p4Title': 'Gata de automatizare',
  'showcase.p4Text': 'Fiecare strat este disponibil imediat în API, tabele și linkuri.',
  'motionShowcase.badge': 'Animație',
  'motionShowcase.title': 'Banner static transformat în animație cu un clic',
  'motionShowcase.subtitle':
    'Apasă „Animează”: titlul, fotografia, prețul și butonul primesc fiecare propria mișcare. Fără timeline și cadre cheie.',
  'motionShowcase.static': 'Static',
  'motionShowcase.animated': 'Animat',
  'motionShowcase.formats': 'MP4 · WebM · GIF',
  'motionShowcase.hint': 'Este o randare reală: schimbă stilurile',
  'motionShowcase.p1Title': 'Un singur clic',
  'motionShowcase.p1Text':
    'Serviciul recunoaște singur titlul, fotografia, prețul și butonul și dă fiecărui strat propria intrare, în ordinea citirii.',
  'motionShowcase.p2Title': 'Un stil pentru fiecare sarcină',
  'motionShowcase.p2Text':
    'Lin, energic, reduceri, kinetic, elegant și altele. Poți ajusta rezultatul manual.',
  'motionShowcase.p3Title': 'Sute de reclame animate',
  'motionShowcase.p3Text':
    'Același șablon, din tabel, feed sau API, generează MP4, WebM și GIF în toate dimensiunile, inclusiv Stories și Reels.',
  'previewMode.title': 'Mod previzualizare',
  'previewMode.text':
    'Fiecare generare din spațiul de lucru — API, automatizări, linkuri și editor — primește filigran și nu consumă din cota ta. Util cât configurezi o integrare; dezactivează-l când ești gata.',
  'previewMode.on': 'Modul previzualizare este activ',
  'previewMode.off': 'Modul previzualizare este dezactivat',
  'previewMode.banner':
    'Mod previzualizare: toate generările au filigran și nu consumă din cota ta.',
  'previewMode.manage': 'Dezactivează',
  'linked.masterChip': 'Set: {n} dimensiuni',
  'linked.sizeChip': 'Dimensiune a „{name}”',
  'linked.changedN': 'modificate: {n}',
  'linked.setTitle': 'Dimensiuni legate',
  'linked.addSize': 'Adaugă o dimensiune',
  'linked.addSizeHint':
    'Același design în altă dimensiune. Modificările originalului ajung în toate dimensiunile, iar cele făcute manual într-o dimensiune rămân',
  'linked.addSizeTileHint': 'Story, postare, banner — modificările se preiau',
  'linked.resetAll': 'Resetează toate modificările acestei dimensiuni',
  'linked.unlink': 'Dezleagă de original',
  'linked.masterHint':
    'Modificările acestui șablon ajung în toate dimensiunile. Ce a fost modificat manual într-o dimensiune se păstrează.',
  'linked.sizeHint':
    'Editările originalului ajung aici automat. Straturile modificate aici sunt marcate cu un punct și nu sunt suprascrise.',
  'linked.layerChanged':
    'Modificat în această dimensiune — editările originalului nu îl vor suprascrie',
  'linked.resetLayer': 'Resetează',
  'linked.changesTitle': 'Modificat în această dimensiune',
  'linked.changesHint': 'Ce a schimbat această dimensiune față de original și cum se resetează',
  'linked.selectLayer': 'Selectează stratul',
  'linked.resetLayerHint': 'Readu stratul ca în original',
  'linked.resetAdded': 'Elimină',
  'linked.resetRemoved': 'Restaurează',
  'linked.changeAdded': 'doar în această dimensiune',
  'linked.changeRemoved': 'șters în această dimensiune',
  'linked.propPosition': 'poziție',
  'linked.propSize': 'dimensiune',
  'linked.propRotation': 'rotire',
  'linked.propLayout': 'aranjare',
  'linked.propText': 'text',
  'linked.propFont': 'font',
  'linked.propColor': 'culoare',
  'linked.propImage': 'imagine',
  'linked.propVisibility': 'vizibilitate',
  'linked.propMotion': 'animație',
  'linked.propOther': 'proprietăți',
  'linked.option': 'Leagă de original',
  'linked.optionHint':
    'Modificările originalului ajung automat în această dimensiune; editările tale din ea se păstrează.',
  'linked.optionPaid':
    'Dimensiunile legate sunt disponibile în Pro și Business: editezi un șablon și se actualizează toate dimensiunile.',
  'linked.badgeSize': 'dimensiune legată',
  'linked.badgeMaster': 'set · {n}',
  'billing.fLinked': 'Dimensiuni legate',
  'quality.title': 'Verificare calitate',
  'quality.found': '{n} din {total} bannere au probleme',
  'quality.clean': 'Verificare calitate: nicio problemă găsită ({total})',
  'quality.checking': 'Verificăm calitatea pe măsură ce imaginile sunt generate…',
  'quality.hint':
    'Text tăiat sau micșorat mult, imagini lipsă sau neclare, straturi în afara pânzei.',
  'quality.showIssues': 'Arată doar cele cu probleme',
  'quality.showAll': 'Arată tot',
  'quality.markerTitle': 'Probleme: {n}',
  'issue.text_overflow': 'textul nu încape și este tăiat',
  'issue.text_shrunk': 'textul a fost micșorat de la {from} la {to} px ca să încapă',
  'issue.image_missing': 'imaginea nu s-a putut încărca',
  'issue.image_lowres': 'imagine de {width}×{height} mărită de {upscale}× — va arăta neclar',
  'issue.offcanvas': 'stratul este în afara pânzei',
  'linked.original': 'original',
  'linked.setHeader': 'Set „{name}”',
  'linked.setCount': '{n} dimensiuni',
  'linked.setHint': 'editările originalului ajung în toate dimensiunile',
  'linked.filterAll': 'Toate',
  'linked.filterSets': 'Seturi',
  'linked.filterSingles': 'Individuale',
  'linked.backToAll': 'Toate șabloanele',
  'linked.allSizes': 'Toate dimensiunile',
  'linked.allSizesHint':
    'Arată toate dimensiunile setului una lângă alta pe aceeași pânză. Modificările originalului se văd imediat în toate dimensiunile',
  'linked.openSize': 'Clic pentru a edita această dimensiune',
  'linked.fitAll': 'Arată toate dimensiunile',
  'linked.fitCurrent': 'Doar dimensiunea deschisă',
  'editor.paddingX': 'Stânga și dreapta',
  'editor.paddingY': 'Sus și jos',
  'editor.paddingSides': 'Fiecare latură separat',
  'editor.paddingAxes': 'Orizontal și vertical',
  'editor.pad_top': 'Sus',
  'editor.pad_right': 'Dreapta',
  'editor.pad_bottom': 'Jos',
  'editor.pad_left': 'Stânga',
  'billing.status.active': 'activ',
  'billing.status.trialing': 'perioadă de probă',
  'billing.status.past_due': 'plată eșuată',
  'billing.status.unpaid': 'neplătit',
  'billing.status.canceled': 'anulat',
  'billing.status.expired': 'încheiat',
  'billing.card': 'Card {brand} •••• {last4}',
  'billing.graceTitle': 'Plata a eșuat',
  'billing.graceText':
    'Actualizează metoda de plată — altfel, după {date}, spațiul de lucru trece de la {plan} la Free.',
  'billing.unpaidTitle': 'Abonament suspendat',
  'billing.unpaidText':
    'Nu am primit plata, așa că spațiul de lucru este pe planul Free. Actualizează cardul — planul revine imediat după plată.',
  'billing.updateCard': 'Actualizează metoda de plată',
  'billing.history': 'Istoric plăți',
  'billing.invoice': 'Factură',
  'billing.reason.initial': 'Abonament',
  'billing.reason.renewal': 'Reînnoire',
  'billing.reason.update': 'Schimbare de plan',
  'billing.graceBanner': 'Plata a eșuat — planul funcționează până la {date}:',
  'billing.graceBannerLink': 'Actualizează cardul',
  'admin.prices': 'Prețuri',
  'admin.pricesHint':
    'Prețurile planurilor în fiecare monedă. Vizitatorii văd moneda țării lor, iar plata se încasează în {currency}.',
  'admin.currencyOn': 'Afișează',
  'admin.perMonth': 'pe lună',
  'admin.perYear': 'pe an',
  'admin.pricesSaved': 'Prețurile au fost salvate',
  'admin.pricesReset': 'Prețuri implicite',
  'admin.chargeCurrency': 'moneda de plată',
  'billing.chargedMonth': 'Se încasează {amount} pe lună',
  'billing.chargedYear': 'Se încasează {amount} pe an',
  'billing.billedYearly': '{amount} facturat anual',
  'err.network': 'Nu există conexiune la server. Verifică internetul și încearcă din nou.',
  'err.seePlans': 'Planuri',
  'err.internal': 'Ceva n-a mers bine la noi. Încearcă din nou peste un minut.',
  'err.validation': 'Verifică câmpurile completate.',
  'err.notFound': 'Nu a fost găsit — poate a fost deja șters.',
  'err.forbidden': 'Nu ai permisiunea pentru această acțiune.',
  'err.tooLarge': 'Fișierul este prea mare.',
  'err.rateLimited': 'Prea multe cereri. Încearcă din nou peste {seconds} s.',
  'err.signIn': 'Sesiunea a expirat — autentifică-te din nou.',
  'err.notMember': 'Nu ești membru al acestui spațiu de lucru.',
  'err.roleRequired': 'Este necesar rolul „{role}” sau unul superior.',
  'err.templateLimit':
    'Planul tău permite maximum {limit} șabloane. Treci la un plan superior ca să creezi mai multe.',
  'err.membersLimit':
    'Planul tău permite maximum {limit} membri. Treci la un plan superior ca să inviți mai multe persoane.',
  'err.automationsLimit':
    'Planul tău permite maximum {limit} automatizări. Treci la un plan superior ca să adaugi mai multe.',
  'err.customSizesLimit': 'Planul {plan} permite maximum {limit} dimensiuni proprii.',
  'err.customSizesPlan':
    'Dimensiunile proprii nu sunt disponibile în planul {plan}. Treci la un plan superior ca să le salvezi.',
  'err.rendersLimit':
    'Ai folosit limita lunară de generări ({used} din {limit} în planul {plan}). Treci la un plan superior ca să continui.',
  'err.aiLimit': 'Ai folosit limita lunară de cereri AI ({used} din {limit} în planul {plan}).',
  'err.storageLimit':
    'Spațiul de stocare este plin (limită: {mb} MB). Șterge fișierele inutile sau treci la un plan superior.',
  'err.batchLimit':
    'Planul {plan} generează maximum {limit} imagini per rulare (cerute: {requested}).',
  'err.scaleLimit': 'Scara {scale}× nu este disponibilă în planul {plan} (maximum {max}×).',
  'err.scaleTooLarge':
    'Șablonul „{name}” poate fi mărit cel mult {max}x: imaginile au cel mult {side} px pe latură și {mpx} Mpx.',
  'err.outputTooLarge':
    'Imaginea ar avea {width}×{height} px, iar maximul este {max} px pe latură. Folosește o scară mai mică.',
  'err.linkedSizesPlan': 'Dimensiunile legate sunt disponibile începând cu planul Pro.',
  'err.customFontsPlan': 'Fonturile proprii sunt disponibile începând cu planul Pro.',
  'err.integrationsPlan': 'Google Drive și S3 sunt disponibile în planurile plătite.',
  'err.schedulePlan': 'Rularea programată este disponibilă începând cu planul Pro.',
  'err.signedUrlsPlan': 'Linkurile semnate către imagini sunt disponibile în planurile plătite.',
  'err.templateInvalid':
    'Șablonul este deteriorat și nu poate fi salvat. Reîncarcă pagina și încearcă din nou.',
  'err.sizeRange': 'Lățimea și înălțimea trebuie să fie numere întregi între {min} și {max} px.',
  'err.templateConflict':
    'Șablonul a fost modificat în altă filă sau de un coleg. Reîncarcă pagina ca să obții ultima versiune.',
  'err.notLinkedSize': 'Acest șablon nu este legat de cel principal.',
  'err.layerInvalid': 'Stratul „{layer}”: {detail}',
  'err.batchEmpty': 'Nu e nimic de generat: nu există rânduri.',
  'err.zipNotReady': 'Arhiva ZIP încă se pregătește — mai așteaptă puțin.',
  'err.fileTooLarge': 'Fișierul este prea mare: maximum {mb} MB.',
  'err.imageType':
    'Acceptate: imagini PNG, JPG, WEBP, GIF, AVIF și SVG, video MP4, MOV și WEBM și muzică MP3, M4A, WAV, OGG și FLAC.',
  'err.imageDownload': 'Nu am putut descărca imaginea de la link (HTTP {status}).',
  'err.urlUnreachable': 'Linkul nu este accesibil. Verifică adresa — trebuie să fie publică.',
  'err.noFile': 'Alege un fișier.',
  'err.fontType': 'Încarcă un font TTF, OTF, WOFF sau WOFF2.',
  'err.fontFamilyRequired': 'Introdu numele fontului.',
  'err.csvParse': 'Nu am putut citi fișierul CSV: {detail}',
  'err.jsonInvalid': 'Linkul nu returnează JSON.',
  'err.jsonShape': 'JSON-ul trebuie să fie o listă de obiecte (sau {"rows": [...]}).',
  'err.sheetLink': 'Acesta nu pare un link către Google Sheets.',
  'err.sheetPrivate':
    'Foaia este privată. Partajeaz-o cu „Oricine are linkul” sau conectează un cont Google.',
  'err.sourceAccessDenied': 'Accesul la date a fost refuzat (HTTP {status}).',
  'err.sourceHttp': 'Sursa de date a returnat o eroare (HTTP {status}).',
  'err.sourceEmpty': 'Sursa de date nu are rânduri.',
  'err.noHeaderRow': 'Fișierul nu are un rând cu antetele coloanelor.',
  'err.apiSource':
    'Această automatizare primește rândurile prin API — rulează-o cu POST /v1/automations/{id}/runs.',
  'err.apiRowsRequired': 'Trimite rândurile („rows”) ca să o rulezi.',
  'err.templatesMissing': 'Unele șabloane alese nu mai există — alege-le din nou.',
  'err.templatesGone': 'Șabloanele alese nu mai există — alege altele.',
  'err.scheduleApi': 'Automatizările cu date din API nu pot rula programat.',
  'err.cronInvalid': 'Programarea nu este validă.',
  'err.endpointInvalid': 'Adresa serverului: {detail}',
  'err.bucketWrite': 'Nu am putut scrie în bucket: {detail}',
  'err.signupsDisabled': 'Înregistrarea pe acest server este închisă.',
  'err.emailTaken': 'Există deja un cont cu acest email — autentifică-te.',
  'err.badCredentials': 'Email sau parolă greșită.',
  'err.accountBlocked': 'Acest cont este blocat. Contactează asistența.',
  'err.resetInvalid': 'Linkul de resetare este invalid sau a expirat — cere unul nou.',
  'err.wrongPassword': 'Parola actuală este greșită.',
  'err.googleDisabled': 'Google nu este configurat pe acest server.',
  'err.googleError': 'Google a returnat o eroare: {detail}',
  'err.googleNoRefresh':
    'Google nu a acordat acces permanent. Elimină accesul aplicației din contul Google și conectează-te din nou.',
  'err.googleNoEmail': 'Contul tău Google nu are un email verificat.',
  'err.googleOtherAccount': 'Acest email este legat de alt cont Google.',
  'err.ownerOnlyTransfer': 'Doar proprietarul poate transfera proprietatea.',
  'err.lastOwner': 'Spațiul de lucru trebuie să aibă cel puțin un proprietar.',
  'err.ownerOnlyRemoveOwner': 'Doar un proprietar poate elimina un proprietar.',
  'err.inviteOwner': 'Invită persoana ca administrator și transferă proprietatea mai târziu.',
  'err.alreadyMember': 'Această persoană este deja membru.',
  'err.invitationInvalid': 'Această invitație este invalidă sau a expirat.',
  'err.invitationOtherEmail':
    'Invitația a fost trimisă la {email}. Autentifică-te cu acest email ca s-o accepți.',
  'err.adminOnlyRemove': 'Doar administratorii pot elimina membri.',
  'err.onlyWorkspace': 'Nu poți șterge singurul spațiu de lucru.',
  'err.cancelBeforeDelete': 'Mai întâi anulează abonamentul, apoi șterge spațiul de lucru.',
  'err.blockSelf': 'Nu te poți bloca pe tine.',
  'err.deleteSelf': 'Nu te poți șterge pe tine.',
  'err.deleteSuperadmin': 'Nu poți șterge un superadministrator.',
  'err.paymentsDisabled': 'Plățile nu sunt configurate pe acest server.',
  'err.paymentProvider': 'Serviciul de plată a returnat o eroare — încearcă din nou.',
  'err.planNotForSale': 'Acest plan nu poate fi cumpărat încă.',
  'err.noSubscription': 'Acest spațiu de lucru nu are încă un abonament.',
  'err.portalUnavailable': 'Portalul de facturare nu este disponibil acum — încearcă mai târziu.',
  'err.cancelInPortal': 'Anulează abonamentul din portalul de facturare.',
  'err.planSwitchDisabled': 'Schimbarea planului fără plată este dezactivată.',
  'err.pricesChargeCurrency':
    'Sunt necesare prețuri în {currency}: plățile se încasează în această monedă.',
  'err.aiDisabled': 'Funcțiile AI sunt dezactivate pe acest server.',
  'err.aiBusy': 'AI-ul este ocupat acum — încearcă peste un minut.',
  'err.code.bad_request': 'N-a mers — verifică datele și încearcă din nou.',
  'err.code.validation_error': 'Verifică câmpurile completate.',
  'err.code.unauthorized': 'Autentifică-te.',
  'err.code.forbidden': 'Nu ai permisiunea pentru această acțiune.',
  'err.code.not_found': 'Nu a fost găsit — poate a fost deja șters.',
  'err.code.conflict': 'Conflict cu datele actuale — reîncarcă pagina.',
  'err.code.plan_limit': 'Indisponibil în planul tău.',
  'err.code.quota_exceeded': 'Ai atins limita planului tău.',
  'err.code.payment_required': 'Este necesar un plan plătit.',
  'err.code.rate_limited': 'Prea multe cereri — încearcă peste un minut.',
  'err.code.payload_too_large': 'Fișierul este prea mare.',
  'err.code.unsupported_media_type': 'Acest tip de fișier nu este acceptat.',
  'err.code.internal_error': 'Ceva n-a mers bine la noi. Încearcă din nou peste un minut.',
  'err.code.service_unavailable': 'Serviciul este temporar indisponibil — încearcă mai târziu.',
  'err.field.required': 'Completează câmpul „{field}”',
  'err.field.choose': 'Alege cel puțin unul: „{field}”',
  'err.field.minLength': '„{field}”: lungime minimă — {n}',
  'err.field.maxLength': '„{field}”: lungime maximă — {n}',
  'err.field.min': '„{field}”: cel puțin {n}',
  'err.field.max': '„{field}”: cel mult {n}',
  'err.field.email': 'Introdu un email valid',
  'err.field.url': '„{field}”: introdu un link complet care începe cu https://',
  'err.field.invalid': 'Verifică câmpul „{field}”',
  'field.name': 'Nume',
  'field.templateIds': 'Șabloane',
  'field.dataSource.url': 'Link către date',
  'field.dataSource.rows': 'Tabel',
  'field.dataSource.columns': 'Coloanele tabelului',
  'field.dataSource.sheet': 'Foaie',
  'field.dataSource.integrationId': 'Cont Google',
  'field.mapping.rules.layer': 'Stratul din regulă',
  'field.mapping.rules.column': 'Coloana din regulă',
  'field.mapping.rules.value': 'Valoarea din regulă',
  'field.output.formats': 'Formate de fișier',
  'field.output.scale': 'Scară',
  'field.output.quality': 'Calitate',
  'field.output.filenamePattern': 'Numele fișierelor',
  'field.destinations.url': 'URL webhook',
  'field.destinations.folderName': 'Dosar în Google Drive',
  'field.destinations.integrationId': 'Cont pentru export',
  'field.destinations.prefix': 'Dosar în bucket',
  'field.schedule.cron': 'Programare',
  'field.schedule.timezone': 'Fus orar',
  'field.email': 'Email',
  'field.password': 'Parolă',
  'field.newPassword': 'Parolă nouă',
  'field.currentPassword': 'Parola actuală',
  'field.workspaceName': 'Numele spațiului de lucru',
  'field.width': 'Lățime',
  'field.height': 'Înălțime',
  'field.brief': 'Descriere',
  'field.text': 'Text',
  'field.url': 'Link',
  'field.bucket': 'Bucket',
  'field.region': 'Regiune',
  'field.endpoint': 'Adresa serverului (endpoint)',
  'field.publicBaseUrl': 'Adresa publică a fișierelor',
  'field.accessKeyId': 'Access Key ID',
  'field.secretAccessKey': 'Secret Access Key',
  'field.defaultWebhookUrl': 'Webhook implicit',
  'field.family': 'Numele fontului',
  'field.tags': 'Etichete',
  'field.format': 'Format',
  'field.scale': 'Scară',
  'field.quality': 'Calitate',
  'field.modifications': 'Datele straturilor',
  'common.more': 'Mai mult',
  'common.name': 'Nume',
  'common.notFound': 'Nu a fost găsit',
  'common.nothingFound': 'Nu s-a găsit nimic',
  'common.open': 'Deschide',
  'common.openNewTab': 'Deschide într-o filă nouă',
  'common.save': 'Salvează',
  'common.saved': 'Salvat',
  'common.search': 'Caută',
  'common.uploading': 'Se încarcă…',
  'role.owner': 'Proprietar',
  'role.admin': 'Administrator',
  'role.editor': 'Editor',
  'role.viewer': 'Observator',
  'nav.templates': 'Șabloane',
  'nav.automations': 'Automatizări',
  'nav.renders': 'Generări',
  'nav.assets': 'Bibliotecă media',
  'nav.fonts': 'Fonturi',
  'nav.api': 'API și chei',
  'nav.integrations': 'Integrări',
  'nav.settings': 'Setări',
  'nav.billing': 'Plan și facturare',
  'nav.developers': 'Dezvoltatori',
  'nav.workspace': 'Spațiu de lucru',
  'nav.workspaces': 'Spații de lucru',
  'nav.newWorkspace': 'Spațiu de lucru nou',
  'nav.profile': 'Profil',
  'nav.logout': 'Deconectează-te',
  'nav.rendersThisMonth': 'Generări în această perioadă',
  'nav.upgrade': 'Fă upgrade',
  'auth.google': 'Continuă cu Google',
  'auth.or': 'sau',
  'auth.error.google_denied': 'Autentificarea cu Google a fost anulată',
  'auth.error.google_state': 'Sesiunea de autentificare a expirat, încearcă din nou',
  'auth.error.google_failed': 'Nu te-am putut autentifica cu Google',
  'auth.error.google_unavailable': 'Autentificarea cu Google nu este configurată pe acest server',
  'settings.setPassword': 'Setează o parolă',
  'settings.googleNoPassword':
    'Te autentifici cu Google. Setează o parolă ca să te poți autentifica și cu emailul.',
  'auth.loginTitle': 'Autentifică-te în Bannermatic',
  'auth.loginSubtitle': 'Bine ai revenit',
  'auth.signupTitle': 'Creează-ți contul',
  'auth.signupSubtitle': 'Plan gratuit — fără card de credit',
  'auth.email': 'Email',
  'auth.password': 'Parolă',
  'auth.passwordHint': 'Cel puțin 8 caractere',
  'auth.name': 'Nume',
  'auth.company': 'Companie sau echipă',
  'auth.companyHint': 'Numele spațiului de lucru — îl poți schimba mai târziu',
  'auth.forgot': 'Ai uitat parola?',
  'auth.loginButton': 'Autentifică-te',
  'auth.signupButton': 'Creează cont',
  'auth.noAccount': 'Nu ai cont?',
  'auth.haveAccount': 'Ai deja cont?',
  'auth.signupLink': 'Înregistrează-te',
  'auth.loginLink': 'Autentifică-te',
  'auth.freePlanNote': '50 de generări gratuite în fiecare lună',
  'auth.forgotTitle': 'Resetează parola',
  'auth.forgotSubtitle': 'Îți trimitem pe email un link de resetare',
  'auth.forgotSent': 'Dacă există contul, emailul este pe drum. Verifică-ți căsuța de email.',
  'auth.sendLink': 'Trimite linkul',
  'auth.resetTitle': 'Setează o parolă nouă',
  'auth.newPassword': 'Parolă nouă',
  'auth.resetButton': 'Salvează parola',
  'auth.resetDone': 'Parola a fost schimbată — autentifică-te',
  'invite.title': 'Invitație în echipă',
  'invite.text': 'Ai fost invitat în „{workspace}” ca {role}.',
  'invite.accept': 'Acceptă invitația',
  'invite.signup': 'Creează un cont pentru {email}',
  'templates.description': 'Șabloane de bannere cu straturi dinamice pentru API și automatizări',
  'templates.new': 'Șablon nou',
  'templates.newTitle': 'Șablon nou',
  'templates.untitled': 'Fără titlu',
  'templates.createAndEdit': 'Creează și deschide editorul',
  'templates.customSize': 'Dimensiune personalizată',
  'templates.groupSocial': 'Rețele sociale',
  'templates.groupAds': 'Reclame display',
  'templates.groupWeb': 'Web și email',
  'templates.groupVideo': 'Video',
  'templates.groupPrint': 'Tipar',
  'templates.count': '{n} în total',
  'templates.emptyTitle': 'Creează primul tău șablon',
  'templates.emptyText':
    'Proiectează un banner, dă straturilor nume clare și generează sute de variante prin API sau dintr-un tabel.',
  'templates.duplicateAs': 'Copie în altă dimensiune',
  'templates.duplicateAsHint':
    'Straturile se adaptează conform comportamentului lor la redimensionare — apoi verifică aspectul.',
  'templates.duplicated': 'Copie creată',
  'sizes.mine': 'Dimensiunile tale',
  'sizes.standard': 'Standard',
  'sizes.save': 'Salvează dimensiunea',
  'sizes.saved': 'Dimensiune salvată în spațiul de lucru',
  'sizes.paid': 'Dimensiuni proprii pentru orice platformă — de la Starter în sus',
  'sizes.limit': 'Planul tău permite până la {n} dimensiuni proprii',
  'sizes.namePlaceholder': 'Nume, de ex. „Ecran recepție”',
  'billing.fSizes': 'Până la {n} dimensiuni proprii',
  'billing.fSizesUnlimited': 'Dimensiuni proprii nelimitate',
  'templates.copyName': '{name} (copie)',
  'duplicate.menu': 'Duplică…',
  'duplicate.title': 'Duplică șablonul',
  'duplicate.sameSize': 'Aceeași dimensiune {size}',
  'duplicate.otherSize': 'Altă dimensiune + auto layout',
  'templates.exportJson': 'Exportă JSON',
  'templates.importTitle': 'Importă șablon',
  'templates.importHint':
    'SVG din Figma (Copy as SVG sau Export → SVG), fișiere .json din Bannermatic sau exporturi Placid, mai multe odată',
  'templates.dropJson': 'Trage fișierele sau dă clic pentru a alege',
  'templates.figmaTitle': 'Cum exporți din Figma',
  'templates.figmaStep1': 'Selectează cadrul bannerului (Frame, nu un grup).',
  'templates.figmaStep2': 'În Export (dreapta jos) apasă „+” și alege SVG.',
  'templates.figmaStep3':
    'Apasă „…” lângă SVG și debifează „Outline text” ca textele să rămână text.',
  'templates.figmaStep4': 'Apasă Export și trage fișierul .svg aici.',
  'templates.figmaNote':
    'Mai rapid: clic dreapta pe cadru → Copy/Paste as → Copy as SVG și Ctrl+V (⌘V) aici, dar textele vin atunci ca contururi. Fonturile lipsă se înlocuiesc cu unele asemănătoare și sunt evidențiate — încarcă-le pentru o potrivire exactă.',
  'templates.svg.fontsReplaced':
    'Lipsesc fonturile din design, înlocuite temporar: {fonts}. Aceste texte sunt evidențiate în editor — încarcă fonturile și aplică-le cu un clic.',
  'templates.svg.uploadFonts': 'Încarcă fonturi',
  'templates.svg.outlined':
    'Textele din acest SVG sunt contururi și nu pot fi editate. În Figma: Export → SVG → „…” → debifează „Outline text” și importă din nou. Sau selectează imaginea în editor → „E text?”.',
  'editor.missingFontTitle': 'Fontul „{font}” nu este încărcat',
  'editor.missingFontText':
    'Textul e afișat cu {used} — așa va ieși și la randare. Încarcă fontul în pagina „Fonturi” și aici va apărea butonul „Aplică”.',
  'editor.missingFontFound': 'Fontul {font} există deja în spațiu.',
  'editor.missingFontApply': 'Aplică {font}',
  'editor.missingFontUpload': 'Încarcă fontul',
  'editor.missingFontKeep': 'Păstrează {used}',
  'editor.fontNotInWorkspace':
    'Acest font nu este în spațiu. Editorul îl poate afișa din fonturile computerului tău, dar randările vor folosi alt font. Încarcă fișierul fontului sau alege altul.',
  'editor.textFromImageTitle': 'E text?',
  'editor.textFromImageHint':
    'Figma exportă des textele ca contururi. Transformă imaginea în text editabil în același loc.',
  'editor.textFromImageManual': 'Înlocuiește cu un strat de text',
  'editor.textFromImagePlaceholder': 'Text',
  'templates.importButton': 'Import: Figma, JSON',
  'templates.importing': 'Import… imaginile se încarcă în bibliotecă',
  'templates.importFormats': 'SVG din Figma · .json Bannermatic · export Placid',

  'templates.svg.invalid': 'Nu am putut citi SVG-ul. Exportă cadrul din Figma ca SVG',
  'templates.svg.empty': 'Nu s-au găsit straturi în SVG',
  'templates.svg.tooMany': 'SVG-ul are peste 500 de straturi — simplifică designul',
  'templates.imported': 'Șablon importat',
  'templates.deleteTitle': 'Ștergi șablonul?',
  'templates.deleteText': '„{name}” nu va mai fi disponibil pentru API și automatizări.',
  'gallery.open': 'Bibliotecă de șabloane',
  'gallery.title': 'Bibliotecă de șabloane',
  'gallery.description':
    'Machete gata făcute, construite cu stive: pune-ți textele și imaginile sau schimbă dimensiunea — aspectul se adaptează.',
  'gallery.all': 'Toate',
  'gallery.use': 'Folosește',
  'gallery.created': 'Șablon creat',
  'gallery.fromLibrary': 'Sau pornește de la un șablon gata făcut',
  'gallery.cat.sale': 'Reduceri',
  'gallery.cat.ecommerce': 'Produse',
  'gallery.cat.event': 'Evenimente',
  'gallery.cat.social': 'Social',
  'gallery.cat.food': 'Mâncare și cafenele',
  'gallery.cat.realestate': 'Imobiliare',
  'gallery.cat.education': 'Educație',
  'gallery.cat.hiring': 'Recrutare',
  'gallery.cat.travel': 'Călătorii',
  'gallery.cat.fitness': 'Fitness',
  'gallery.cat.holiday': 'Sărbători',
  'gallery.cat.ads': 'Bannere web',
  'gallery.cat.beauty': 'Frumusețe',
  'gallery.cat.auto': 'Auto',
  'gallery.cat.tech': 'Tehnologie',
  'gallery.cat.pets': 'Animale',
  'ai.create': 'Creează cu AI',
  'ai.regenerate': 'Mai multe variante',
  'ai.credits': 'Solicitări AI: {used} din {limit} luna aceasta',
  'ai.disabled': 'Generarea cu AI nu este configurată pe server (GEMINI_API_KEY).',
  'aiVideo.title': 'Video din descriere',
  'aiVideo.placeholder':
    'De ex.: lansarea aplicației Nova de montaj, cu 48% mai rapid, stil întunecat',
  'aiVideo.generate': 'Creează video',
  'aiVideo.generating': 'AI regizează variantele…',
  'aiVideo.style_launch': 'Lansare produs',
  'aiVideo.style_showreel': 'Showreel',
  'aiVideo.style_manifesto': 'Manifest',
  'aiVideo.style_data': 'Povestea în cifre',
  'aiVideo.style_brand': 'Film de brand',
  'director.title': 'Regizor AI',
  'director.description':
    'Descrie ce îți trebuie și pentru ce. Un agent compune singur videoclipul sau bannerul cu uneltele editorului: scene, texte și fonturi, fotografii, grafică animată, efecte de text, tranziții, cameră și muzică. Apoi îl editezi ca pe orice șablon.',
  'director.video': 'Video',
  'director.banner': 'Banner',
  'director.placeholderVideo':
    'De ex.: video de lansare pentru Nova, aplicație de montaj. Public: creatori. Esențial: montaj cu 48% mai rapid. Energic, întunecat cu portocaliu, la final „Descarcă gratuit”.',
  'director.placeholderBanner':
    'De ex.: banner de reduceri de vară la adidași RUNNER, -30% până duminică, viu și sportiv, buton „Cumpără”.',
  'director.run': 'Creează',
  'director.again': 'Altă variantă',
  'director.open': 'Deschide în editor',
  'director.mockNote': 'Mod de test fără cheie API: agentul rulează un scenariu pregătit.',
  'director.logHint': 'Aici vei vedea cum agentul compune lucrarea, pas cu pas.',
  'director.thinking': 'Agentul gândește ideea și storyboard-ul…',
  'director.working': 'Agentul lucrează · pasul {n}',
  'director.fixed': 'Greșeli corectate pe parcurs: {n}',
  'director.previewHint': 'Aici apare rezultatul',
  'director.tool_plan_style': 'Stil',
  'director.tool_add_scene': 'Scenă',
  'director.tool_add_text': 'Text',
  'director.tool_add_shape': 'Formă',
  'director.tool_add_photo': 'Foto',
  'director.tool_add_graphic': 'Grafică',
  'director.tool_add_camera': 'Cameră',
  'director.tool_set_music': 'Muzică',
  'director.tool_finish': 'Gata',
  'director.tool_add_logo': 'Logo',
  'director.tool_update': 'Modificare',
  'director.tool_remove': 'Eliminare',
  'director.tool_update_scene': 'Modificare scenă',
  'director.tool_review': 'Verificare',
  'director.reviewFound': 'observații: {n} — le corectez',
  'director.reviewClean': 'nicio observație',
  'director.brandDefault': 'Brand: {name}',
  'director.brandNone': 'Fără brand',
  'director.brandHint':
    'Culorile, fonturile și logo-ul din brand kit: rezultatul rămâne legat de brand',
  'dictation.start': 'Dictează',
  'dictation.stop': 'Oprește dictarea',
  'dictation.listening': 'Ascult…',
  'dictation.lang': 'Limba dictării',
  'dictation.denied': 'Fără acces la microfon — permite-l în browser',
  'dictation.failed': 'Recunoașterea vocală a eșuat',
  'ai.copyVariants': 'Variante de text AI',
  'ai.copyHint': 'Dă click pentru a folosi o variantă. Anulează cu Ctrl+Z.',
  'billing.fAi': 'Solicitări AI pe lună: {n}',
  'billing.aiPeriod': 'Solicitări AI în perioada curentă',
  'editor.dropImages': 'Eliberează pentru a încărca fișierele',
  'editor.saved': 'Salvat',
  'editor.unsaved': 'Modificări nesalvate',
  'editor.saving': 'Se salvează…',
  'editor.saveError': 'Salvarea a eșuat',
  'editor.conflict': 'Conflict de versiuni',
  'editor.conflictTitle': 'Șablonul a fost modificat în altă parte',
  'editor.conflictText':
    'Cineva a salvat acest șablon în timp ce îl editai. Îl suprascrii cu versiunea ta? „Anulează” reîncarcă cea mai recentă versiune.',
  'editor.overwrite': 'Suprascrie',
  'editor.undo': 'Anulează',
  'editor.redo': 'Refă',
  'editor.zoomIn': 'Mărește',
  'editor.zoomOut': 'Micșorează',
  'editor.zoomFit': 'Potrivește pe ecran',
  'editor.zoom100': 'Zoom 100%',
  'editor.selectAll': 'Selectează toate straturile',
  'editor.rename': 'Redenumește',
  'editor.resize': 'Redimensionează',
  'editor.testRender': 'Generează',
  'editor.readOnly': 'Ai acces doar pentru vizualizare.',
  'editor.tabElements': 'Elemente',
  'editor.tabMedia': 'Media',
  'editor.tabLayers': 'Straturi',
  'editor.text': 'Text',
  'editor.addHeading': 'Titlu',
  'editor.addSubheading': 'Subtitlu',
  'editor.addBody': 'Text de bază',
  'editor.presetHeading': 'Titlu',
  'editor.presetSubheading': 'Subtitlu',
  'editor.presetBody': 'Text de bază. Dă dublu click pentru a edita.',
  'editor.addBadge': 'Insignă −30%',
  'editor.shapes': 'Forme',
  'editor.shapeRectangle': 'Dreptunghi',
  'editor.shapeRounded': 'Rotunjit',
  'editor.shapeEllipse': 'Elipsă',
  'editor.shapeTriangle': 'Triunghi',
  'editor.shapeLine': 'Linie',
  'editor.shapeDiamond': 'Romb',
  'editor.shapePolygon': 'Poligon',
  'editor.shapeStar': 'Stea',
  'editor.shapeBurst': 'Explozie',
  'editor.shapeHeart': 'Inimă',
  'editor.shapeArrow': 'Săgeată',
  'editor.shapeChevron': 'Chevron',
  'editor.shapeCross': 'Plus',
  'editor.shapeBubble': 'Balon',
  'editor.shapeRibbon': 'Panglică',
  'editor.shapeTag': 'Etichetă',
  'editor.shapeParallelogram': 'Paralelogram',
  'editor.shapeSemicircle': 'Semicerc',
  'editor.shapeBlob': 'Pată',
  'editor.shapeIcon': 'Pictogramă',
  'editor.shapePoints': 'Colțuri',
  'editor.shapeSides': 'Laturi',
  'editor.shapeInner': 'Adâncime',
  'editor.secTextStyles': 'Stiluri de text',
  'editor.secStickers': 'Stickere și insigne',
  'editor.secIcons': 'Pictograme',
  'editor.secInfo': 'Contact și informații',
  'editor.secDecor': 'Rame și decor',
  'editor.secOverlays': 'Fundaluri și suprapuneri',
  'editor.iconSearch': 'Caută: phone, gift, star…',
  'editor.noIcons': 'Nimic găsit',
  'editor.showAllIcons': 'Arată toate ({n})',
  'editor.showLess': 'Arată mai puțin',
  'editor.elCta': 'Buton',
  'editor.txtCta': 'Cumpără acum',
  'editor.elKicker': 'Supratitlu',
  'editor.txtKicker': 'Noutatea sezonului',
  'editor.elHighlight': 'Evidențiere',
  'editor.txtHighlight': 'Doar azi',
  'editor.elOutline': 'Contur',
  'editor.elNeon': 'Neon',
  'editor.txtNeon': 'Deschis',
  'editor.elScript': 'Scris de mână',
  'editor.txtScript': 'Cu drag',
  'editor.elElegant': 'Elegant',
  'editor.elPoster': 'Afiș',
  'editor.elQuote': 'Citat',
  'editor.txtQuote': '„Cea mai bună cafea din oraș!”',
  'editor.elPrice': 'Preț redus',
  'editor.elFineprint': 'Notă',
  'editor.txtFineprint': '*Ofertă valabilă până pe 31 decembrie',
  'editor.elSale': 'Reduceri',
  'editor.txtSale': 'SALE',
  'editor.elDiscount': 'Reducere',
  'editor.elNew': 'Nou',
  'editor.txtNew': 'NOU',
  'editor.elRibbon': 'Panglică',
  'editor.txtRibbon': 'CEL MAI VÂNDUT',
  'editor.elTag': 'Etichetă',
  'editor.elBubble': 'Replică',
  'editor.txtBubble': 'Wow!',
  'editor.elLove': 'Inimă',
  'editor.elShipping': 'Livrare',
  'editor.txtShipping': 'Livrare gratuită',
  'editor.elRating': 'Rating',
  'editor.elTimer': 'Cronometru',
  'editor.elPhone': 'Telefon',
  'editor.elAddress': 'Adresă',
  'editor.txtAddress': 'Str. Principală 1',
  'editor.elWebsite': 'Site',
  'editor.elDate': 'Dată',
  'editor.txtDate': '12 mai · 19:00',
  'editor.elSocial': 'Social',
  'editor.elChecklist': 'Listă',
  'editor.txtChecklist': 'Avantaj {n}',
  'editor.elFrame': 'Ramă',
  'editor.elDashedFrame': 'Ramă punctată',
  'editor.elRing': 'Inel',
  'editor.elDivider': 'Accent',
  'editor.elDottedLine': 'Puncte',
  'editor.elCircles': 'Cercuri',
  'editor.elBlob': 'Pată',
  'editor.elShadeBottom': 'Umbră jos',
  'editor.elShadeTop': 'Umbră sus',
  'editor.elShadeLeft': 'Umbră stânga',
  'editor.elVignette': 'Vinietă',
  'editor.elTint': 'Nuanțare',
  'editor.elDuotone': 'Duoton',
  'editor.elHalfPanel': 'Jumătate',
  'editor.elDiagonal': 'Diagonală',
  'editor.elArc': 'Arc jos',
  'editor.stockPhotos': 'Fotografii',
  'editor.stockHint':
    'Fotografii royalty-free: le poți folosi în bannere comerciale fără atribuire. Clic pentru a insera sau a înlocui imaginea selectată.',
  'editor.photoTag.all': 'Toate',
  'editor.photoTag.people': 'Oameni',
  'editor.photoTag.beauty': 'Frumusețe',
  'editor.photoTag.food': 'Mâncare',
  'editor.photoTag.travel': 'Călătorii',
  'editor.photoTag.home': 'Casă',
  'editor.photoTag.business': 'Afaceri',
  'editor.photoTag.sport': 'Sport',
  'editor.photoTag.holiday': 'Sărbători',
  'editor.photoTag.auto': 'Auto',
  'editor.photoTag.pets': 'Animale',
  'editor.photoTag.nature': 'Natură',
  'editor.dynamic': 'Dinamice',
  'editor.imagePlaceholder': 'Foto / logo',
  'editor.qr': 'Cod QR',
  'editor.dynamicHint':
    'Orice strat poate fi modificat prin API după numele său: text, imagine, culoare, poziție.',
  'editor.noLayers': 'Încă nu există straturi. Adaugă text, o formă sau o imagine.',
  'editor.uploadImages': 'Încarcă imagini sau video',
  'editor.uploadNew': 'Încarcă altele',
  'editor.mediaHint':
    'Dă click pentru a insera sau pentru a înlocui imaginea selectată. Poți și să tragi fișiere pe pânză.',
  'editor.noUploads': 'Încă nu ai încărcat nimic',
  'editor.removeImage': 'Elimină imaginea',
  'editor.placeholderImage': 'Substituent — imaginea vine din API',
  'editor.replaceImage': 'Înlocuiește imaginea sau video',
  'editor.dropToReplace': 'Eliberează pentru a înlocui',
  'editor.chooseImage': 'Alege imagine sau video',
  'editor.imageUrl': 'sau lipește URL-ul unei imagini',
  'editor.template': 'Șablon',
  'editor.canvasSize': 'Dimensiunea pânzei',
  'editor.customSize': 'Dimensiune personalizată',
  'editor.resizeHint':
    'Cu adaptarea activă, straturile urmează comportamentul lor la redimensionare. Anulează cu Ctrl+Z.',
  'editor.background': 'Fundal',
  'editor.transparentHint': 'Fundalul transparent se păstrează în PNG și WEBP.',
  'editor.tips': 'Sfaturi',
  'editor.tipNames':
    'Dă straturilor nume clare (title, photo, price) — datele sunt asociate cu ele în API și în tabele.',
  'editor.tipShortcuts':
    'Ctrl+Z / Ctrl+Shift+Z, Ctrl+D duplicare, săgețile mută (Shift ×10), Ctrl+rotiță zoom, Space pentru deplasare, ține Alt pentru a măsura distanțele.',
  'editor.tipTools':
    'Instrumente: R dreptunghi, U rotunjit, O elipsă, L linie, T text, H titlu (Shift+H subtitlu), B insignă, I foto, Q QR. Trage pe pânză sau dă click; V sau Esc pentru selecție.',
  'editor.toolHint': '{tool}: trage pe pânză sau dă click · Esc pentru anulare',
  'editor.tipDrop': 'Trage imaginile pe pânză pentru a le încărca.',
  'editor.nameInvalid': 'Numele nu poate conține . = & ? # / \\',
  'editor.nameTaken': 'Acest nume este deja folosit',
  'editor.layerNameHint': 'Numele stratului este cheia API și coloana din tabel',
  'editor.layerDescription': 'Descriere API (opțional)',
  'editor.position': 'Poziție și dimensiune',
  'editor.constraints': 'Comportament la redimensionare',
  'editor.constraintsHint': 'Cum se adaptează stratul când se schimbă dimensiunea șablonului.',
  'editor.cH': 'Orizontal',
  'editor.cV': 'Vertical',
  'editor.c.auto': 'Auto',
  'editor.c.left': 'Stânga',
  'editor.c.right': 'Dreapta',
  'editor.c.top': 'Sus',
  'editor.c.bottom': 'Jos',
  'editor.c.center': 'Centru',
  'editor.c.stretch': 'Întinde',
  'editor.c.scale': 'Scalează',
  'editor.c.proportional': 'proporțional',
  'editor.adaptLayers': 'Adaptează straturile',
  'editor.applySize': 'Aplică dimensiunea',
  'resize.preview': 'Previzualizare',
  'resize.extremeWarning': 'Raportul de aspect se schimbă mult — verifică aspectul după copiere.',
  'editor.stack': 'Stivă',
  'editor.stackExpand': 'Arată straturile stivei',
  'editor.stackCollapse': 'Restrânge stiva',
  'editor.groupStack': 'În stivă',
  'editor.ungroupStack': 'Degrupează',
  'editor.stackLayout': 'Auto layout',
  'editor.dirVertical': 'Coloană',
  'editor.dirHorizontal': 'Rând',
  'editor.dirAuto': 'Auto',
  'editor.dirFree': 'Fără',
  'editor.dirFreeHint':
    'Fără aranjare automată: straturile rămân unde le-ați pus (un text pe un buton) și se mută odată cu stiva. O coloană sau un rând le aliniază automat.',
  'editor.dirAutoHint':
    'Auto: rând când pânza este de cel puțin N ori mai lată decât înaltă, altfel coloană — un singur design pentru formate orizontale și verticale.',
  'editor.autoRowRatio': 'Rând de la N : 1',
  'editor.gap': 'Spațiere',
  'editor.alignItems': 'Aliniere',
  'editor.al.start': 'Început',
  'editor.al.center': 'Centru',
  'editor.al.end': 'Sfârșit',
  'editor.al.stretch': 'Întinde',
  'editor.distribution': 'Distribuire',
  'editor.js.start': 'Început',
  'editor.js.center': 'Centru',
  'editor.js.end': 'Sfârșit',
  'editor.js.space-between': 'Între',
  'editor.clip': 'Decupează conținutul',
  'editor.inStack': 'În stiva „{name}”',
  'editor.selectStack': 'Selectează stiva',
  'editor.grow': 'Umple spațiul liber',
  'editor.earlier': 'Mai devreme',
  'editor.later': 'Mai târziu',
  'editor.stackHint':
    'Straturile din stivă se așază automat: un text mai lung împinge elementele următoare.',
  'editor.stackFeatText': 'Textul mai lung împinge singur straturile următoare',
  'editor.stackFeatGrow':
    'Un strat poate ocupa spațiul liber: activați „Umple spațiul liber” la strat',
  'editor.stackFeatAuto': '„Auto”: rând în dimensiunile late, coloană în cele înalte',
  'editor.groupHint': 'Ctrl+G pune selecția într-o stivă, Ctrl+Shift+G o degrupează.',
  'editor.copy': 'Copiază',
  'editor.paste': 'Lipește',
  'editor.alignToPage': 'Aliniază la pagină',
  'editor.alignSelection': 'Aliniază',
  'editor.order': 'Ordine',
  'editor.setAsBackground': 'Setează ca fundal',
  'editor.editText': 'Editează textul',
  'editor.moreActions': 'Mai multe acțiuni',
  'editor.opacityShort': 'Opac.',
  'editor.alignLeft': 'Aliniază la stânga',
  'editor.alignHCenter': 'Aliniază la centru',
  'editor.alignRight': 'Aliniază la dreapta',
  'editor.alignTop': 'Aliniază sus',
  'editor.alignVCenter': 'Aliniază la mijloc',
  'editor.alignBottom': 'Aliniază jos',
  'editor.justify': 'Justifică',
  'editor.distributeH': 'Distribuie orizontal',
  'editor.distributeV': 'Distribuie vertical',
  'editor.arrange': 'Strat',
  'editor.bringFront': 'Adu în față',
  'editor.bringForward': 'Adu mai în față',
  'editor.sendBackward': 'Trimite mai în spate',
  'editor.sendBack': 'Trimite în spate',
  'editor.lock': 'Blochează',
  'editor.unlock': 'Deblochează',
  'editor.hide': 'Ascunde',
  'editor.show': 'Arată',
  'editor.duplicate': 'Duplică',
  'editor.layersSelected': '{n} straturi selectate',
  'editor.clearSelection': 'Anulează selecția',
  'editor.typography': 'Tipografie',
  'editor.italic': 'Cursiv',
  'editor.lineHeight': 'Înălțimea rândului',
  'editor.lineHeightShort': '↕',
  'editor.letterSpacing': 'Spațiere între litere',
  'editor.letterSpacingShort': '↔',
  'editor.transformNone': 'Cum a fost scris',
  'editor.uppercase': 'MAJUSCULE',
  'editor.lowercase': 'minuscule',
  'editor.capitalize': 'Prima Literă Mare',
  'editor.dynamicText': 'Text lung',
  'editor.autoFit': 'Micșorează fontul ca să încapă în casetă',
  'editor.minFontSize': 'Dimensiune min.',
  'editor.maxLines': 'Max. rânduri',
  'editor.autoFitHint':
    'Util pentru textul din API: textul scurt rămâne mare, cel lung se micșorează. 0 rânduri = nelimitat.',
  'editor.textBox': 'Casetă de text',
  'editor.padding': 'Spațiere interioară',
  'editor.radius': 'Rază',
  'editor.effects': 'Efecte',
  'editor.stroke': 'Contur',
  'editor.shadow': 'Umbră',
  'editor.blurShort': 'Blur',
  'editor.image': 'Imagine sau video',
  'editor.fitCover': 'Acoperă',
  'editor.fitContain': 'Încadrează',
  'editor.fitFill': 'Întinde',
  'editor.focusX': 'Focus X',
  'editor.focusY': 'Focus Y',
  'editor.videoClip': 'Video',
  'editor.videoClipHint':
    'Clip de {s} s: rulează în animații și video; imaginile arată primul cadru.',
  'editor.videoLoop': 'Buclă',
  'editor.videoSound': 'Cu sunet',
  'editor.videoVolume': 'Volum',
  'editor.videoTrim': 'Fragment din clip',
  'editor.videoRemove': 'Păstrează doar cadrul',
  'editor.videoPlay': 'Previzualizează video',
  'editor.videoPause': 'Oprește previzualizarea',
  'editor.videoMute': 'Fără sunet',
  'editor.videoUnmute': 'Pornește sunetul',
  'err.videoUnreadable': 'Videoclipul nu a putut fi citit: încărcați MP4, MOV sau WEBM.',
  'editor.imageApiHint':
    'Transmite un URL prin API: {"photo": "https://…"}. Fotografia este decupată în jurul punctului de focus.',
  'editor.style': 'Stil',
  'editor.border': 'Bordură',
  'editor.brightness': 'Luminozitate',
  'editor.blur': 'Estompare',
  'editor.grayscale': 'Alb-negru',
  'editor.flipX': 'Oglindește orizontal',
  'editor.flipY': 'Oglindește vertical',
  'editor.shape': 'Formă',
  'editor.line': 'Linie',
  'editor.width': 'Grosime',
  'editor.strokeSolid': 'Continuă',
  'editor.strokeDashed': 'Întreruptă',
  'editor.strokeDotted': 'Punctată',
  'editor.qrColor': 'Culoare',
  'editor.qrMargin': 'Margine',
  'editor.qrLevel': 'Nivel de corecție',
  'editor.pickColor': 'Alege culoarea',
  'editor.docColors': 'Culorile șablonului',
  'fold.autoFit': 'potrivire font',
  'fold.maxLines': 'max. {n} rânduri',
  'fold.words': 'cuvinte: {n}',
  'fold.numbers': 'cifre',
  'accent.bar': 'Accent',
  'accent.bold': 'Mai gros',
  'accent.underline': 'Subliniat',
  'accent.marker': 'Marker',
  'accent.markerOn': 'Adaugă marker',
  'accent.markerOff': 'Elimină markerul',
  'accent.remove': 'Elimină accentul',
  'accent.more': 'Culoare proprie, marker, mărime…',
  'accent.textColor': 'Text',
  'accent.size': 'Mărime',
  'accent.wordTitle': 'Accent „{word}”',
  'accent.dragHint': 'Trageți-l pentru a vedea toată compoziția',
  'accent.title': 'Accente în text',
  'accent.hint':
    'Dublu clic pe text, selectați un cuvânt și alegeți o culoare deasupra lui sau adăugați cuvântul aici. Cuvântul e evidențiat în orice text care îl conține, inclusiv în datele din tabel.',
  'accent.wordPlaceholder': 'Un cuvânt sau o frază',
  'accent.add': 'Adaugă',
  'accent.dataTitle': 'Accent din date',
  'accent.numbers': 'Cifre și procente ca accent',
  'accent.dataHint':
    'În tabel sau API: **cuvânt** în textul celulei, o coloană „{layer}.accent” cu cuvântul (mai multe separate prin „;”) sau „{layer}.accent_color” cu o culoare.',
  'editor.colorOpacity': 'Opacitate',
  'editor.fillNone': 'Fără',
  'editor.fillSolid': 'Culoare',
  'editor.fillLinear': 'Liniar',
  'editor.fillRadial': 'Radial',
  'editor.angle': 'Unghi',
  'editor.addStop': 'Adaugă punct',
  'editor.searchFonts': 'Caută fonturi',
  'editor.manageFonts': 'Gestionează și încarcă fonturi',
  'editor.weight100': 'Thin',
  'editor.weight200': 'ExtraLight',
  'editor.weight300': 'Light',
  'editor.weight400': 'Regular',
  'editor.weight500': 'Medium',
  'editor.weight600': 'SemiBold',
  'editor.weight700': 'Bold',
  'editor.weight800': 'ExtraBold',
  'editor.weight900': 'Black',
  'preview.title': 'Generare',
  'preview.description': 'Completează datele și vezi rezultatul exact cum îl returnează API-ul.',
  'preview.formatImage': 'Imagine',
  'preview.formatVideo': 'Video',
  'preview.deviceHint':
    'Videoclipul se face pe acest calculator. Nu închide fila până nu se termină.',
  'preview.noFields': 'Șablonul nu are încă straturi.',
  'preview.render': 'Generează',
  'preview.rendering': 'Se generează…',
  'preview.empty': 'Rezultatul va apărea aici',
  'preview.openPdf': 'Deschide PDF',
  'apiDialog.title': 'Generează prin API',
  'apiDialog.description': 'Straturile acestui șablon și exemple de cereri gata de folosit',
  'apiDialog.reference': 'Documentația completă API',
  'apiDialog.layer': 'Strat',
  'apiDialog.type': 'Tip',
  'apiDialog.properties': 'Proprietăți',
  'apiDialog.hint':
    'Creează o cheie API în „API și chei”. În loc de obiect poți transmite un șir: "title": "Text" sau "photo": "https://…".',
  'resize.title': 'Copie în altă dimensiune',
  'resize.description': 'Creăm o copie și adaptăm straturile la noua dimensiune',
  'resize.preset': 'Presetări',
  'resize.choosePreset': 'Alege o dimensiune…',
  'resize.hint':
    'Șabloanele de dimensiuni diferite cu aceleași nume de straturi pot fi generate într-o singură rulare a automatizării.',
  'resize.limitHint': 'Planul tău permite până la {n} șabloane.',
  'resize.createCopy': 'Creează copia',
  'resize.created': 'Copie creată',
  'automations.description':
    'Generare în masă: date × șabloane → fișiere în ZIP, Google Drive, S3 sau un webhook',
  'automations.new': 'Automatizare nouă',
  'automations.emptyTitle': 'Încă nu ai automatizări',
  'automations.emptyText':
    'Încarcă un CSV sau conectează un Google Sheet, alege șabloanele și obține sute de materiale cu un singur click sau după un program.',
  'automations.disabled': 'Dezactivată',
  'automations.neverRun': 'Nu a rulat niciodată',
  'automations.runNow': 'Rulează acum',
  'automations.howTitle': 'Cum funcționează',
  'automations.how1':
    'Alege unul sau mai multe șabloane (de ex. pătrat, story și un banner 728×90).',
  'automations.how2': 'Conectează datele: CSV, Google Sheet, un URL JSON/CSV sau rânduri prin API.',
  'automations.how3':
    'Asociază coloanele cu straturile — coloanele numite ca straturile sunt asociate automat.',
  'automations.how4': 'Alege formatele și destinațiile. Rulează manual, după program sau din API.',
  'automations.source.table': 'Tabel / CSV',
  'automations.source.google_sheets': 'Google Sheet',
  'automations.source.url': 'URL (CSV/JSON/XML)',
  'automations.source.api': 'Rânduri prin API',
  'automation.namePlaceholder': 'Numele automatizării, de ex. „Carduri de produs”',
  'automation.enabled': 'Activă',
  'automation.fold': 'Restrânge',
  'automation.unfold': 'Extinde',
  'automation.pickTemplates': 'Alege șabloane ({n})',
  'automation.changeTemplates': 'Schimbă selecția',
  'automation.searchTemplates': 'Caută șablon',
  'automation.pickDone': 'Gata — mai departe, datele',
  'automation.sumTemplates': 'Alese: {n}',
  'automation.sumNoTemplates': 'Niciun șablon ales',
  'automation.sumRows': 'rânduri: {n}',
  'automation.sumAuto': 'după numele straturilor',
  'automation.sumRules': 'reguli: {n}',
  'automation.sumWebhook': 'Webhook',
  'automation.sumManual': 'Manual sau prin API',
  'automation.step1': 'Șabloane',
  'automation.step1Hint':
    'Fiecare rând de date este generat cu fiecare șablon selectat. Alege un set pentru a adăuga toate dimensiunile lui.',
  'automation.noTemplates': 'Creează mai întâi un șablon.',
  'automation.step2': 'Date',
  'automation.step2Hint': 'Un rând = un set de materiale',
  'automation.uploadCsv': 'Încarcă CSV',
  'automation.csvLoaded': '{n} rânduri încărcate',
  'automation.columnsFromLayers': 'Coloane din straturi',
  'automation.addColumn': 'Coloană',
  'automation.addRow': 'Rând',
  'automation.rowsCount': '{n} rânduri',
  'automation.rowsHidden': 'Încă {n} rânduri sunt ascunse, dar vor fi generate.',
  'automation.tableHint':
    'O coloană numită ca un strat (title) setează valoarea lui principală; „strat.proprietate” (title.color) setează o proprietate. Celulele goale păstrează valoarea din șablon.',
  'automation.sheetUrl': 'Link către Google Sheet',
  'automation.sheetHint':
    'Un sheet partajat prin link funcționează fără conectarea unui cont. Primul rând trebuie să conțină antetele.',
  'automation.googleAccount': 'Cont Google',
  'automation.publicSheet': 'Link public (fără cont)',
  'automation.sheetName': 'Foaie',
  'automation.firstSheet': 'prima foaie',
  'automation.testSource': 'Testează și previzualizează datele',
  'automation.sourceOk': '{n} rânduri, {c} coloane încărcate',
  'automation.urlHint': 'Se preia la fiecare rulare — ideal pentru feeduri de produse',
  'automation.xmlHint':
    'Feeduri Google Merchant și Meta (RSS/Atom), YML pentru Rozetka și Prom sau orice XML. Fiecare produs primește coloanele title, price, old_price, discount, currency, image, link, brand, category — denumește straturile la fel și se completează singure.',
  'automation.onlyChanged': 'Doar rândurile noi și modificate',
  'automation.onlyChangedHint':
    'O rulare randează doar ce e nou sau modificat de data trecută (preț, fotografie, nume). Dacă schimbi șablonul, maparea sau formatul, se randează totul din nou. Ideal pentru un feed zilnic: nu consumă randări pe aceleași bannere.',
  'automation.keyColumn': 'Coloana de identificare',
  'automation.keyColumnHint': 'Recunoaște rândul de la o rulare la alta — de obicei id sau SKU',
  'automation.keyWholeRow': '— întregul rând —',
  'automation.unchangedShort': 'neschimbate: {n}',
  'batch.unchanged': 'Rânduri neschimbate omise: {n}',
  'batch.nothingChanged':
    'Nimic nu s-a schimbat de la ultima rulare ({n} rânduri) — nu s-au consumat randări.',
  'err.xmlEntities': 'XML cu declarații de entități (<!ENTITY>) nu este acceptat',
  'err.xmlParse': 'Nu am putut citi XML-ul: {detail}',
  'err.feedEmpty': 'Nu s-au găsit produse în feedul XML',
  'automation.format': 'Format',
  'automation.apiHint':
    'Rândurile sunt trimise în corpul cererii — util pentru CRM-uri, n8n, Make și Zapier.',
  'automation.step3': 'Asocierea câmpurilor',
  'automation.step3Hint': 'Ce intră în fiecare strat',
  'automation.autoMap': 'Asociază automat după nume',
  'automation.autoMapHint': 'Coloanele care corespund numelor straturilor sunt asociate automat',
  'automation.selectTemplatesFirst': 'Selectează șabloanele pentru a vedea straturile lor.',
  'automation.templatesLoadFailed': 'Câmpurile șabloanelor nu au putut fi încărcate.',
  'automation.noFieldsInTemplates': 'Șabloanele selectate nu au straturi de completat.',
  'automation.value': 'Valoare',
  'automation.sample': 'Exemplu (rândul 1)',
  'automation.inTemplates': 'în {n} din {total}',
  'automation.auto': 'Auto: coloana {column}',
  'automation.keepTemplate': 'Păstrează valoarea din șablon',
  'automation.column': 'Coloană',
  'automation.static': 'Valoare fixă',
  'automation.extraRules': 'Reguli suplimentare',
  'automation.extraRulesHint':
    'De ex. culoarea insignei dintr-o coloană „color” sau o culoare fixă a textului.',
  'automation.addRule': 'Adaugă regulă',
  'automation.previewFirstRow': 'Previzualizează primul rând',
  'automation.livePreview': 'Previzualizare live',
  'automation.prevRow': 'Rândul anterior',
  'automation.nextRow': 'Rândul următor',
  'automation.rowN': 'rândul {n} din {total}',
  'automation.livePreviewHint':
    'Treceți peste un strat din tabel pentru a-l evidenția aici. Clic pe un element al designului pentru a-i găsi rândul.',
  'automation.livePreviewMedia': 'Imaginile din biblioteca media ({layers}) se pun la generare',
  'automation.livePreviewFailed':
    'Valoarea nu se potrivește, stratul rămâne ca în șablon: {layers}',
  'automation.lockedLayer': 'Blocat în editor: automatizarea nu îl schimbă',
  'automation.step4': 'Rezultat',
  'automation.formats': 'Formate',
  'automation.scale': 'Scară',
  'automation.scaleCapped':
    'Șabloanele mari ies mai mici: {list}. Imaginile au cel mult {side} px pe latură și {mpx} Mpx.',
  'automation.scaleNotUsed':
    'PDF este vectorial, iar videoclipurile păstrează dimensiunea șablonului: scara nu se aplică.',
  'automation.quality': 'Calitate JPG/WEBP',
  'automation.filename': 'Numele fișierului',
  'automation.filenameHint':
    'Substituenți: {{template}}, {{index}}, {{date}}, {{format}}, {{row.column}}',
  'automation.folders': 'Foldere pentru fișiere',
  'automation.foldersHint':
    'Pentru ZIP, Google Drive și S3. Alegeți în ordine cum se sortează fișierele: primul este folderul exterior. Fără alegere, toate fișierele stau împreună.',
  'automation.folderExampleTemplate': 'Șablon',
  'automation.folderBy.template': 'După șablon',
  'automation.folderBy.size': 'După dimensiune',
  'automation.folderBy.format': 'După format',
  'automation.folderBy.column': 'După coloană',
  'automation.step5': 'Destinații',
  'automation.step5Hint': 'Alege una sau mai multe',
  'automation.destZip': 'Arhivă ZIP de descărcat',
  'automation.connectGoogle': 'Conectează Google',
  'automation.connectS3': 'Conectează S3',
  'automation.folderName': 'Folder',
  'automation.subfolderPerRun': 'Subfolder pentru fiecare rulare',
  'automation.step6': 'Program',
  'automation.step6Hint': 'De ex. preia feedul în fiecare dimineață și actualizează materialele',
  'automation.scheduleOn': 'Rulează după program',
  'automation.frequency': 'Frecvență',
  'automation.timezone': 'Fus orar',
  'automation.nextRuns': 'Următoarele rulări',
  'automation.invalidCron': 'Expresie cron invalidă',
  'automation.cron.hourly': 'În fiecare oră',
  'automation.cron.daily': 'Zilnic la 9:00',
  'automation.cron.weekly': 'Lunea la 9:00',
  'automation.cron.monthly': 'Lunar, pe 1, la 9:00',
  'automation.cron.custom': 'Personalizat',
  'automation.runs': 'Istoric rulări',
  'automation.estimate': 'Vor fi generate {n} fișiere',
  'automation.estimateUnknown': 'Numărul se cunoaște după încărcarea datelor',
  'automation.overLimit': 'peste limita planului tău ({n} per rulare)',
  'automation.saveAndRun': 'Salvează și rulează',
  'automation.saved': 'Automatizare salvată',
  'automation.deleteTitle': 'Ștergi automatizarea?',
  'automation.deleteText': 'Istoricul rulărilor și fișierele generate se păstrează.',
  'destination.zip': 'Arhivă ZIP',
  'destination.google_drive': 'Google Drive',
  'destination.s3': 'Amazon S3 / compatibil',
  'destination.webhook': 'Webhook',
  'batch.title': 'Rulare',
  'batch.status.pending': 'Se pregătește',
  'batch.status.processing': 'Se generează',
  'batch.status.done': 'Finalizat',
  'batch.status.partial': 'Parțial',
  'batch.status.failed': 'Eșuat',
  'batch.trigger.manual': 'manual',
  'batch.trigger.schedule': 'după program',
  'batch.trigger.api': 'prin API',
  'batch.total': 'total',
  'batch.done': 'finalizate',
  'batch.failed': 'eșuate',
  'batch.finished': 'Finalizat',
  'batch.downloadZip': 'Descarcă ZIP',
  'batch.deliveries': 'Livrare',
  'batch.files': '{n} fișiere',
  'batch.showingFirst': 'Se afișează primele 200 de fișiere — toate fișierele sunt în arhiva ZIP.',
  'renders.description': 'Toate imaginile și fișierele PDF generate',
  'renders.tabRenders': 'Fișiere',
  'renders.tabBatches': 'Loturi',
  'renders.allStatuses': 'Toate stările',
  'renders.allSources': 'Toate sursele',
  'renders.file': 'Fișier',
  'renders.status': 'Stare',
  'renders.source': 'Sursă',
  'renders.size': 'Dimensiune',
  'renders.created': 'Creat',
  'renders.duration': 'Durată',
  'renders.modifications': 'Modificări',
  'renders.emptyTitle': 'Încă nu există generări',
  'renders.emptyText': 'Rulează o automatizare sau apelează API-ul — rezultatele apar aici.',
  'renders.noBatches': 'Încă nu există loturi',
  'renders.loadMore': 'Încarcă mai multe',
  'renders.sources.api': 'API',
  'renders.sources.editor': 'Editor',
  'renders.sources.automation': 'Automatizare',
  'renders.sources.url': 'URL semnat',
  'renders.statuses.queued': 'În coadă',
  'renders.statuses.rendering': 'Se generează',
  'renders.statuses.done': 'Finalizat',
  'renders.statuses.failed': 'Eșuat',
  'assets.description': 'Fotografii, logouri și pictograme pentru șabloanele tale',
  'assets.storage': 'Stocare: {used} din {limit}',
  'assets.drop':
    'Trage imagini sau video ori apasă pentru a alege (PNG, JPG, WEBP, SVG, GIF, MP4, MOV, WEBM)',
  'assets.importUrl': 'Importă din URL',
  'assets.emptyTitle': 'Biblioteca ta media este goală',
  'assets.emptyText': 'Încarcă logouri și fotografii pentru a le folosi în șabloane.',
  'assets.copyUrl': 'Copiază URL-ul',
  'assets.deleteTitle': 'Ștergi fișierul?',
  'assets.deleteText': 'Șabloanele care îl folosesc vor afișa o zonă goală.',
  'fonts.description':
    'Activează fonturile de care ai nevoie și încarcă fonturile brandului — disponibile în editor și la generare',
  'fonts.custom': 'Fonturi proprii',
  'fonts.builtin': 'Încorporate',
  'fonts.customBadge': 'propriu',
  'fonts.customLocked': 'Fonturi proprii în planurile Pro și Business',
  'fonts.filterAll': 'Toate',
  'fonts.filterEnabled': 'Activate',
  'fonts.filterCyrillic': 'Chirilice',
  'fonts.sampleText': 'Muzicologă în bej vând whisky și tequila, preț fix.',
  'fonts.cyrillic': 'Chirilic',
  'fonts.cyrShort': 'Chir',
  'fonts.sample': 'Text de previzualizare',
  'fonts.enabledCount': '{n} din {total} activate',
  'fonts.disableHint':
    'Fonturile dezactivate sunt ascunse în editor, iar șabloanele existente continuă să fie generate corect.',
  'fonts.files': 'Fișiere încărcate',
  'fonts.uploadTitle': 'Încarcă font',
  'fonts.uploadHint':
    'TTF, OTF, WOFF sau WOFF2. Încarcă fiecare grosime ca fișier separat, cu aceeași familie.',
  'fonts.dropFont': 'Trage aici un fișier de font sau dă click',
  'fonts.family': 'Familie',
  'fonts.familyHint': 'Lasă gol pentru a o citi din fișier',
  'fonts.weight': 'Grosime',
  'fonts.style': 'Stil',
  'fonts.auto': 'Detectează automat',
  'fonts.upload': 'Încarcă',
  'fonts.uploaded': 'Fontul {family} {weight} a fost încărcat',
  'fonts.deleteTitle': 'Ștergi fișierul de font?',
  'fonts.deleteText': 'Șabloanele care folosesc această grosime vor trece la alt font.',
  'api.description': 'Conectează generarea la site-ul, CRM-ul sau scripturile tale',
  'api.keys': 'Chei API',
  'api.keysHint':
    'O cheie oferă acces la toate șabloanele din spațiul de lucru. Păstreaz-o pe serverul tău.',
  'api.createKey': 'Creează cheie',
  'api.adminOnly': 'Doar administratorii pot gestiona cheile.',
  'api.noKeys': 'Încă nu există chei',
  'api.created': 'creată',
  'api.lastUsed': 'folosită',
  'api.neverUsed': 'nefolosită niciodată',
  'api.revoke': 'Revocă',
  'api.revokeTitle': 'Revoci cheia?',
  'api.revokeText': 'Cererile cu „{name}” nu vor mai funcționa imediat.',
  'api.keyCreated': 'Cheie creată',
  'api.copyNow': 'Copiază cheia acum — nu o vom mai afișa.',
  'api.keyNameHint': 'De ex. unde este folosită',
  'api.quickstart': 'Pornire rapidă',
  'api.reference': 'Documentație',
  'api.tabSingle': 'O imagine',
  'api.tabBatch': 'Lot',
  'api.tabAsync': 'Asincron',
  'api.layersHelp':
    'modificări după numele stratului: un șir setează valoarea principală, un obiect setează proprietăți, null ascunde stratul.',
  'api.scaleHelp': '2 pentru retina.',
  'api.webhookHelp': 'te anunțăm când fișierul este gata (semnat cu HMAC).',
  'api.signedTitle': 'URL-uri semnate pentru imagini',
  'api.signedHint':
    'Imaginea este generată la prima cerere și pusă în cache. Ideal pentru emailuri, Open Graph și landing pages — fără cod pe server.',
  'api.generateUrl': 'Generează URL',
  'api.urlAppearsHere': 'URL-ul și previzualizarea apar aici',
  'api.signingSecret': 'Secret de semnare',
  'api.signingSecretHint':
    'Folosit pentru semnarea URL-urilor și a webhookurilor. Semnează URL-urile la tine — vezi exemplul.',
  'api.reveal': 'Afișează',
  'api.rotate': 'Rotește secretul',
  'api.rotateTitle': 'Rotești secretul?',
  'api.rotateText':
    'Toate URL-urile semnate emise anterior nu vor mai funcționa, iar webhookurile vor folosi noul secret.',
  'integrations.description': 'De unde vin datele și unde ajung fișierele',
  'integrations.locked': 'Integrările sunt disponibile de la Starter în sus.',
  'integrations.googleHint': 'Citește Google Sheets și încarcă fișiere în Google Drive',
  'integrations.googleNotConfigured':
    'Google OAuth nu este configurat pe server (GOOGLE_CLIENT_ID / GOOGLE_CLIENT_SECRET). Sheet-urile publice funcționează și fără el.',
  'integrations.connectGoogle': 'Conectează contul Google',
  'integrations.googleConnected': 'Google conectat',
  'integrations.googleReconnected': 'Acest cont Google era deja conectat — accesul a fost reînnoit',
  'integrations.googleFailed': 'Nu s-a putut conecta Google',
  'integrations.s3Short': 'AWS, Cloudflare R2, MinIO, Wasabi, DigitalOcean…',
  'integrations.addBucket': 'Adaugă bucket',
  'integrations.s3Title': 'Conectează S3',
  'integrations.s3Hint': 'Verificăm accesul scriind un fișier marker .bannermatic-check',
  'integrations.endpointHint': 'Pentru alți furnizori decât AWS',
  'integrations.publicBase': 'URL public de bază (opțional)',
  'integrations.testAndSave': 'Testează și salvează',
  'integrations.connected': 'Conectat',
  'integrations.webhooks': 'Webhookuri',
  'integrations.webhooksHint':
    'Notificări POST despre generările și loturile finalizate, semnate cu HMAC-SHA256',
  'integrations.defaultWebhook': 'Webhook implicit pentru automatizări',
  'integrations.defaultWebhookHint': 'Primește batch.completed după fiecare rulare',
  'integrations.testWebhook': 'Testează webhookul',
  'integrations.send': 'Trimite',
  'integrations.testSent': 'Eveniment de test pus în coadă',
  'integrations.verifyTitle': 'Verifică semnătura',
  'integrations.recentDeliveries': 'Livrări recente',
  'integrations.removeTitle': 'Elimini integrarea?',
  'integrations.removeText': 'Automatizările care o folosesc nu vor mai putea livra fișierele.',
  'settings.tabGeneral': 'General',
  'settings.tabMembers': 'Echipă',
  'settings.tabBilling': 'Facturare',
  'settings.tabProfile': 'Profil',
  'settings.workspace': 'Spațiu de lucru',
  'settings.dangerZone': 'Zonă periculoasă',
  'settings.deleteWorkspace': 'Șterge spațiul de lucru',
  'settings.deleteWorkspaceText':
    'Toate șabloanele, fișierele, cheile și istoricul generărilor vor fi șterse. Acțiunea este ireversibilă.',
  'settings.deleteWorkspaceConfirm': 'Sigur ștergi „{name}” cu toate datele sale?',
  'settings.lastWorkspace': 'Acesta este singurul tău spațiu de lucru, deci nu poate fi șters.',
  'workspace.noneTitle': 'Încă nu ai un spațiu de lucru',
  'workspace.noneText':
    'Creează un spațiu de lucru pentru a lucra cu șabloane sau roagă-ți colegii să te invite în al lor.',
  'settings.invite': 'Invită colegi',
  'settings.inviteHint': 'Vom trimite pe email un link de invitație.',
  'settings.seats': 'Locuri: {used} din {limit}.',
  'settings.sendInvite': 'Invită',
  'settings.invited': 'Invitație trimisă',
  'settings.inviteLink': 'Link',
  'settings.you': 'tu',
  'settings.remove': 'Elimină din echipă',
  'settings.pendingInvites': 'Invitații în așteptare',
  'settings.expires': 'expiră',
  'settings.rolesTitle': 'Roluri',
  'settings.roleOwner': 'tot, inclusiv facturarea și ștergerea',
  'settings.roleAdmin': 'echipă, chei API, integrări',
  'settings.roleEditor': 'șabloane, media, fonturi, automatizări și generare',
  'settings.roleViewer': 'vizualizare șabloane și rezultate',
  'settings.language': 'Limba interfeței',
  'settings.changePassword': 'Schimbă parola',
  'settings.currentPassword': 'Parola actuală',
  'settings.passwordChanged': 'Parola a fost schimbată',
  'billing.currentPlan': 'Planul actual',
  'billing.renewsOn': 'Se reînnoiește pe',
  'billing.endsOn': 'Se încheie pe',
  'billing.manage': 'Gestionează abonamentul',
  'billing.rendersPeriod': 'Generări în această perioadă',
  'billing.storage': 'Stocare',
  'billing.plans': 'Planuri',
  'billing.monthly': 'Lunar',
  'billing.yearly': 'Anual (−{n}%)',
  'billing.mo': 'lună',
  'billing.popular': 'Popular',
  'billing.current': 'Planul actual',
  'billing.choose': 'Alege',
  'billing.thanks': 'Mulțumim! Abonamentul tău se activează în cel mult un minut.',
  'billing.switched': 'Plan schimbat',
  'billing.devMode':
    'Plățile nu sunt configurate: modul de dezvoltare îți permite să schimbi planurile fără plată. Conectează Lemon Squeezy (LEMONSQUEEZY_API_KEY) sau Stripe (STRIPE_SECRET_KEY) pentru producție.',
  'billing.noStripe': 'Plățile nu sunt configurate pe acest server. Contactează administratorul.',
  'billing.fRenders': '{n} generări / lună',
  'billing.fTemplates': 'Până la {n} șabloane',
  'billing.fTemplatesUnlimited': 'Șabloane nelimitate',
  'billing.fMembers': 'Până la {n} membri',
  'billing.fMembersUnlimited': 'Membri nelimitați',
  'billing.fAutomations': 'Până la {n} automatizări',
  'billing.fAutomationsUnlimited': 'Automatizări nelimitate',
  'billing.fBatch': 'Până la {n} fișiere per rulare',
  'billing.fFonts': 'Fonturi proprii',
  'billing.fIntegrations': 'Google Drive, Sheets, S3',
  'billing.fSigned': 'URL-uri semnate pentru imagini',
  'billing.fSchedule': 'Automatizări programate',
  'billing.fNoWatermark': 'Fără filigran',
  'landing.navFeatures': 'Funcționalități',
  'landing.navSpreadsheets': 'Tabele',
  'landing.navPricing': 'Prețuri',
  'landing.navDocs': 'Documentație API',
  'landing.login': 'Autentificare',
  'landing.startFree': 'Începe gratuit',
  'landing.openApp': 'Deschide aplicația',
  'landing.badge': 'Șabloane · Tabele · API',
  'landing.title': 'Sute de bannere dintr-un singur șablon — în câteva minute',
  'landing.subtitle':
    'Creează un șablon în editorul vizual, apoi trimite texte, fotografii, prețuri și logouri prin API, Google Sheets sau CSV. Primești PNG, JPG, WEBP și PDF.',
  'landing.ctaPrimary': 'Creează primul șablon',
  'landing.ctaSecondary': 'Vezi API-ul',
  'landing.noCard': 'Plan gratuit pentru totdeauna. Fără card de credit.',
  'landing.demoRows': '{n} rânduri',
  'landing.uc1': 'Carduri de produs pentru marketplace-uri',
  'landing.uc2': 'Reclame display în toate dimensiunile',
  'landing.uc3': 'Postări și stories pentru social media',
  'landing.uc4': 'Imagini OG și bannere pentru email',
  'landing.demo1Title': 'Reduceri de vară',
  'landing.demo1Subtitle': 'Reduceri la toată colecția',
  'landing.demo2Title': 'Noua colecție de pantofi de alergare',
  'landing.demo2Subtitle': 'Ușori, rapizi, respirabili',
  'landing.demo3Title': 'Black Friday',
  'landing.demo3Subtitle': 'Doar 3 zile — grăbește-te',
  'landing.demo4Title': 'Carduri cadou',
  'landing.demo4Subtitle': 'Cadoul perfect de sărbători',
  'landing.demoFrom': 'de la {price}',
  'landing.uc5': 'Certificate și liste de prețuri în PDF',
  'landing.featuresTitle': 'Tot ce ai nevoie pentru automatizarea materialelor',
  'landing.featuresSubtitle':
    'Designerii creează un șablon o singură dată, iar materialele se asamblează singure din API, tabele și feeduri.',
  'landing.f1Title': 'Editor vizual',
  'landing.f1Text':
    'Straturi, text, fotografii, logouri, forme, coduri QR, gradiente, umbre, ghidaje inteligente și text care se ajustează automat.',
  'landing.f2Title': 'REST API',
  'landing.f2Text':
    'Generare sincronă și asincronă, loturi de mii de fișiere, webhookuri semnate și documentație OpenAPI.',
  'landing.f3Title': 'Studio de automatizări',
  'landing.f3Text':
    'CSV, Google Sheets, feeduri de produse Google Merchant, Meta și YML × mai multe șabloane → ZIP, Google Drive, S3 sau webhookuri. După program — doar produsele modificate.',
  'landing.f4Title': 'Fonturile tale',
  'landing.f4Text':
    '40 de fonturi populare cu suport pentru chirilice incluse. Încarcă fonturile brandului TTF/OTF/WOFF și ascunde-le pe celelalte.',
  'landing.f5Title': 'Imagini și video',
  'landing.f5Text':
    'PNG transparent, JPG, WEBP, PDF vectorial pentru tipar, retina până la 3x — și video MP4, WebM, GIF pentru Reels, TikTok și Shorts.',
  'landing.f6Title': 'Precizie la pixel',
  'landing.f6Text':
    'Editorul și serverul folosesc același motor de randare — ce vezi este ce primești.',
  'landing.howTitle': 'Cum funcționează',
  'landing.step1Title': 'Creează un șablon',
  'landing.step1Text':
    'Aranjează straturile în editor și denumește-le pe cele dinamice: title, photo, price.',
  'landing.step2Title': 'Conectează datele',
  'landing.step2Text': 'Trimite JSON către API, încarcă un CSV sau leagă un Google Sheet.',
  'landing.step3Title': 'Primește fișierele',
  'landing.step3Text':
    'Fișierele ajung ca linkuri, într-un ZIP, în Drive, S3 sau pe webhookul tău.',
  'landing.apiTitle': 'Un API ușor de integrat',
  'landing.apiText':
    'O cerere, o imagine. Sau o mie într-un lot. Funcționează din orice limbaj, n8n, Make și Zapier.',
  'landing.api1':
    'Schimbă textul, fotografiile, culorile, pozițiile și vizibilitatea după numele stratului',
  'landing.api2': 'Așteaptă rezultatul în răspuns sau primește un webhook',
  'landing.api3': 'URL-uri semnate — o imagine dintr-un URL, fără cod pe server',
  'landing.api4': 'Limite, chei și jurnale de livrare — totul transparent',
  'landing.apiCalloutTitle': 'Motor de randare automată',
  'landing.apiCalloutText':
    'Transmiteți parametrii straturilor prin API, webhook-uri sau tabele — randare paralelă rapidă.',
  'landing.pricingTitle': 'Prețuri simple',
  'landing.pricingSubtitle':
    'Plătești pentru numărul de generări. Editorul și API-ul sunt incluse în toate planurile.',
  'landing.tryPlan': 'Alege {plan}',
  'landing.watermark': 'Cu filigran',
  'landing.faqTitle': 'Întrebări frecvente',
  'landing.q1': 'Prin ce diferă de un instrument de design obișnuit?',
  'landing.a1':
    'Un instrument de design obișnuit este pentru lucru manual. Bannermatic este pentru volum: un șablon devine automat sute de variante prin API, tabele și programări.',
  'landing.q2': 'Pot muta elementele, nu doar schimba textul?',
  'landing.a2':
    'Da. Pentru orice strat poți transmite x, y, width, height, rotation și opacity, îi poți schimba culoarea (color) sau îl poți ascunde (hide: true sau null), de ex. {"logo": {"x": 40, "y": 860, "width": 180}}. Straturile dintr-o stivă sunt plasate de auto layout — acolo schimbi dimensiunea lor și direcția și spațierea stivei (direction, gap), nu coordonatele.',
  'landing.q3': 'Ce se întâmplă cu un text lung?',
  'landing.a3':
    'Activează ajustarea automată: fontul se micșorează ca să încapă, sau limitează numărul de rânduri cu puncte de suspensie.',
  'landing.metaTitle': 'Bannermatic — Generare automată de bannere prin API și foi de calcul',
  'landing.metaDescription':
    'Editor vizual de șabloane și REST API pentru generarea în masă de bannere, carduri de produse, conținut pentru rețele sociale și PDF din Google Sheets și CSV.',
  'landing.q4': 'Sunt acceptate chirilicele și fonturile proprii?',
  'landing.a4':
    'Da, majoritatea fonturilor încorporate includ chirilice, iar în planurile plătite poți încărca propriile fonturi TTF/OTF/WOFF.',
  'landing.q5': 'Cum se pot genera bannere din Google Sheets fără cunoștințe de programare?',
  'landing.a5':
    'Conectați o foaie Google Sheets sau încărcați un fișier CSV în Studioul de Automatizare. Coloanele se mapează pe straturile șablonului (title, price, photo), iar Bannermatic generează sute de bannere gata de utilizare în arhivă ZIP, Google Drive sau S3.',
  'landing.q6': 'Este potrivit serviciul pentru carduri de produse pe marketplace-uri?',
  'landing.a6':
    'Da, acesta este unul dintre principalele cazuri de utilizare. Puteți aplica în masă etichete de reducere, specificații, prețuri și logo-uri de brand peste fotografiile produselor din flux sau catalog.',
  'landing.finalTitle': 'Nu mai crea bannere manual',
  'landing.finalText': 'Creează un șablon în 10 minute și lasă rutina în seama API-ului.',
  'landing.tablesBadge': 'Fără cod · Studio de tabele',
  'landing.tablesTitle': 'Bannere din tabele fără cod',
  'landing.tablesSubtitle':
    'Conectează Google Sheets sau încarcă un CSV. Coloanele se mapează automat pe straturile șablonului, generând sute de bannere dintr-un singur clic.',
  'landing.tablesPoint1Title': 'Import din Google Sheets și CSV',
  'landing.tablesPoint1Text':
    'Conectează un tabel online sau trage un fișier cu produse. Bannermatic recunoaște instant structura datelor.',
  'landing.tablesPoint2Title': 'Mapare vizuală a coloanelor',
  'landing.tablesPoint2Text':
    'Indică ce coloană corespunde titlului, prețului sau fotografiei. Asistentul inteligent conectează straturile automat.',
  'landing.tablesPoint3Title': 'Randare în serie și export rapid',
  'landing.tablesPoint3Text':
    'Sute de bannere sunt create în paralel în câteva secunde. Descarcă o arhivă ZIP sau salvează direct în cloud.',
  'landing.tablesMascotBubble': 'Adaugă tabelul și gata!',
  'landing.tablesCta': 'Deschide Studioul de automatizare',
  'landing.tablesMockSync': 'Sincronizat · 450 rânduri',
  'landing.tablesMockBtn': 'Generează 450 de bannere',
  'landing.tablesMockColProduct': 'Produs',
  'landing.tablesMockColPrice': 'Preț',
  'landing.tablesMockColDiscount': 'Reducere',
  'landing.tablesMockColPhoto': 'Foto',
  'landing.tablesMockColStatus': 'Status',
  'landing.tablesMockDone': 'Gata',
  'automation.autoMapped': 'Coloane potrivite: {n}',
  'automation.autoMapNone': 'Nu s-au găsit potriviri noi de coloane',
  'automation.matchColumns': 'Potrivește coloanele',
  'automation.mediaHint': 'Celulele cu imagini pot indica fișiere din biblioteca media:',
  'media.allFiles': 'Toate fișierele',
  'media.noFolder': 'Fără dosar',
  'media.folders': 'Dosare',
  'media.newFolder': 'Dosar nou',
  'media.renameFolder': 'Redenumește dosarul',
  'media.renameFile': 'Redenumește fișierul',
  'media.rename': 'Redenumește',
  'media.moveTo': 'Mută în dosar',
  'media.moved': 'Fișier mutat',
  'media.folderPlaceholder': 'de ex. Echipe',
  'media.foldersHint':
    'Organizează siglele și fundalurile în dosare — „Echipe”, „Ligi”… Trage fișierele pe un dosar pentru a le muta.',
  'media.dropInto': 'Trage fișierele aici și ajung în dosarul „{folder}”',
  'media.search': 'Caută după numele fișierului sau dosarului',
  'media.nothingFound': 'Nu s-a găsit nimic',
  'media.copyRef': 'Copiază referința pentru automatizări',
  'media.refCopied': 'Copiat — lipește-l într-o celulă a tabelului sau în API',
  'media.refHint': 'În tabelele de automatizare și în API, indică un fișier așa:',
  'media.exampleFolder': 'Echipe',
  'media.exampleName': 'Arsenal',
  'media.deleteFolderTitle': 'Ștergi dosarul „{name}”?',
  'media.deleteFolderText':
    'Fișierele rămân și trec în „Fără dosar”. Referințele media:Dosar/… nu le vor mai găsi.',
  'media.allFolders': 'Toate dosarele',
  'media.pick': 'Alege din biblioteca media',
  'err.folderExists': 'Există deja un dosar „{name}”',
  'err.nameRequired': 'Introdu un nume',
  'err.mediaNotFound': 'Stratul „{layer}”: „{ref}” nu este în biblioteca media',
  'qr.style': 'Stil cod QR',
  'qr.paid':
    'Puncte rotunjite, stilul colțurilor, culoare proprie și logo în centru — în planurile Pro și Business.',
  'qr.upgrade': 'Schimbă planul',
  'qr.dots': 'Puncte',
  'qr.eyes': 'Colțuri',
  'qr.eyeColor': 'Culoarea colțurilor',
  'qr.logo': 'Logo în centru',
  'qr.logoHint': 'Disponibil în Pro și Business',
  'qr.logoSize': 'Mărime logo',
  'qr.logoNote':
    'Cu logo, codul folosește corecția maximă a erorilor (H) — verifică scanarea în previzualizare.',
  'qr.dot.square': 'Pătrate',
  'qr.dot.rounded': 'Rotunjite',
  'qr.dot.dots': 'Cercuri',
  'qr.eye.square': 'Pătrat',
  'qr.eye.rounded': 'Rotunjit',
  'qr.eye.circle': 'Cerc',
  'billing.fQrStyles': 'Coduri QR stilizate cu logo',
  'retention.label': 'Păstrat',
  'retention.until': 'până la {date}',
  'retention.keptUntil': 'Fișierele sunt păstrate până la {date}',
  'retention.batchExpired': 'Perioada de păstrare a expirat — fișierele au fost șterse',
  'retention.renderExpired': 'Fișierul a fost șters după perioada de păstrare',
  'google.spreadsheet': 'Foaie de calcul',
  'google.chooseSpreadsheet': 'Alege o foaie',
  'google.noSpreadsheets': 'Încă nu sunt foi — alege în Google Drive sau lipește un link',
  'google.listHint':
    'Google arată aplicațiilor doar foile alese prin „Google Drive” sau deja folosite în automatizări.',
  'google.refresh': 'Reîmprospătează lista',
  'google.fromDrive': 'Google Drive',
  'google.orLink': '…sau linkul foii',
  'google.linkedSheet': 'Foaie din link',
  'google.noAccess': 'Acest cont Google nu poate deschide foaia — verifică linkul și partajarea.',
  'google.noAccessPick':
    'Bannermatic vede doar foile alese în Google Drive. Deschide această foaie acolo o dată — accesul va fi doar la ea.',
  'google.grantAccess': 'Dă acces la această foaie',
  'common.loading': 'Se încarcă…',
  'common.retry': 'Reîncearcă',
  'err.pickerOwnerOnly':
    'Doar cine a conectat contul Google (sau un administrator) poate răsfoi Drive-ul',
  'err.pickerDisabled': 'Alegerea din Google Drive nu este configurată pe server',
  'common.close': 'Închide',
  'common.menu': 'Meniu',
  'history.title': 'Istoric versiuni',
  'history.paid':
    'Istoricul șablonului cu revenire la orice versiune salvată — în planul Business.',
  'history.restore': 'Restaurează această versiune',
  'history.restored': 'S-a restaurat versiunea din {time}',
  'history.empty': 'Versiunile apar după primele modificări.',
  'history.current': 'Curentă',
  'history.restoreOf': 'Revenire la versiunea {version}',
  'history.initial': 'Versiunea inițială',
  'history.edited': 'Modificări',
  'history.hint':
    'Modificările unei persoane în ~10 minute formează o versiune. Păstrate 180 de zile, maximum 200 per șablon.',
  'comments.title': 'Comentarii',
  'comments.paid': 'Comentariile pe șabloane pentru revizuire în echipă — în planul Business.',
  'comments.empty': 'Încă nu sunt comentarii. Selectează un strat pentru a atașa o notă.',
  'comments.resolve': 'Marchează rezolvat',
  'comments.reopen': 'Redeschide',
  'comments.showResolved': 'Arată rezolvate ({n})',
  'comments.hideResolved': 'Ascunde rezolvate',
  'comments.placeholder': 'O notă sau o întrebare… (Ctrl+Enter pentru trimitere)',
  'comments.pin': 'La stratul „{layer}”',
  'comments.send': 'Trimite',
  'review.title': 'Aprobare',
  'review.status.draft': 'Ciornă',
  'review.status.in_review': 'În aprobare',
  'review.status.changes_requested': 'De modificat',
  'review.status.approved': 'Aprobat',
  'review.hint.approved': 'Aprobat {time}. Modificările de design îl readuc la ciornă.',
  'review.hint.inReview': 'Așteaptă decizia proprietarului sau a unui administrator.',
  'review.hint.changes':
    'Sunt necesare modificări — vezi comentariile de mai jos, apoi trimite din nou.',
  'review.hint.edited': 'Modificat după aprobare.',
  'review.hint.editedRequired':
    'Modificat după aprobare. API-ul, automatizările și linkurile desenează versiunea aprobată până când cea nouă este aprobată.',
  'review.hint.draft': 'Când designul e gata, trimite-l spre aprobare.',
  'review.hint.draftRequired':
    'Încă neaprobat: API-ul, automatizările și linkurile nu îl randează (previzualizările merg).',
  'review.notePlaceholder': 'Ce trebuie schimbat? Nota ajunge în comentarii',
  'review.sendBack': 'Trimite înapoi',
  'review.approve': 'Aprobă',
  'review.requestChanges': 'Cere modificări',
  'review.request': 'Trimite spre aprobare',
  'review.done.request': 'Trimis spre aprobare',
  'review.done.approve': 'Șablon aprobat',
  'review.done.changes': 'Trimis înapoi pentru modificări',
  'approval.title': 'Cere aprobarea șabloanelor',
  'approval.text':
    'API-ul, automatizările și linkurile semnate randează doar versiunea aprobată a fiecărui șablon. Modificările nu ajung în campanii și feeduri până nu sunt aprobate. Previzualizările și generarea din editor funcționează ca înainte.',
  'approval.on': 'Aprobarea este obligatorie',
  'approval.off': 'Aprobarea nu mai este obligatorie',
  'audit.template.review_requested': 'Trimis spre aprobare:',
  'audit.template.approved': 'Șablon aprobat:',
  'audit.template.changes_requested': 'Trimis înapoi pentru modificări:',
  'err.templateNotApproved':
    'Șablonul „{name}” nu este încă aprobat. Aprobă-l în editor sau dezactivează aprobarea obligatorie.',
  'err.reviewAlreadyApproved': 'Această versiune este deja aprobată',
  'activity.tab': 'Activitate',
  'activity.paid':
    'Jurnalul de activitate — cine ce a modificat și a rulat — este în planul Business. Evenimentele sunt deja înregistrate: după upgrade le vei vedea și pe cele trecute.',
  'activity.description': 'Cine ce a modificat și a rulat. Păstrat 365 de zile.',
  'activity.allTypes': 'Toate evenimentele',
  'activity.empty': 'Încă nu sunt evenimente',
  'activity.more': 'Arată mai mult',
  'activity.times': '×{n}',
  'activity.apiKey': 'Cheie API',
  'activity.system': 'Sistem',
  'activity.version': 'versiunea {n}',
  'activity.renders': '{n} fișiere',
  'activity.trigger.manual': 'manual',
  'activity.trigger.schedule': 'programat',
  'activity.trigger.api': 'prin API',
  'activity.type.template': 'Șabloane',
  'activity.type.automation': 'Automatizări',
  'activity.type.member': 'Echipă',
  'activity.type.api_key': 'Chei API',
  'activity.type.integration': 'Integrări',
  'activity.type.asset': 'Media',
  'activity.type.font': 'Fonturi',
  'audit.template.created': 'Șablon creat:',
  'audit.template.imported': 'Șablon importat:',
  'audit.template.updated': 'Șablon modificat:',
  'audit.template.deleted': 'Șablon șters:',
  'audit.template.duplicated': 'Copie de șablon:',
  'audit.template.restored': 'Șablon readus la o versiune:',
  'audit.comment.added': 'Comentariu la',
  'audit.automation.created': 'Automatizare creată:',
  'audit.automation.updated': 'Automatizare modificată:',
  'audit.automation.deleted': 'Automatizare ștearsă:',
  'audit.automation.run': 'Rulare automatizare:',
  'audit.batch.created': 'Lot generat prin API',
  'audit.member.invited': 'Invitație trimisă către',
  'audit.member.joined': 'S-a alăturat echipei:',
  'audit.member.removed': 'Eliminat din echipă:',
  'audit.member.left': 'A părăsit echipa:',
  'audit.member.role_changed': 'Rol schimbat pentru',
  'audit.invitation.revoked': 'Invitație revocată',
  'audit.api_key.created': 'Cheie API creată:',
  'audit.api_key.revoked': 'Cheie API revocată',
  'audit.integration.connected': 'Integrare conectată:',
  'audit.integration.updated': 'Integrare reconectată:',
  'audit.integration.deleted': 'Integrare eliminată:',
  'audit.asset.uploaded': 'Fișiere încărcate, ultimul:',
  'audit.asset.deleted': 'Fișier șters:',
  'audit.folder.created': 'Dosar creat:',
  'audit.folder.deleted': 'Dosar șters:',
  'audit.font.uploaded': 'Font încărcat:',
  'audit.font.deleted': 'Font șters',
  'audit.motion_preset.created': 'Preset de animație creat:',
  'audit.motion_preset.updated': 'Preset de animație modificat:',
  'audit.motion_preset.deleted': 'Preset de animație șters:',
  'audit.workspace.updated': 'Setările spațiului modificate:',
  'audit.signing_secret.rotated': 'Secret de semnare schimbat',
  'audit.plan.changed': 'Plan schimbat',
  'err.businessFeature': 'Disponibil în planul Business',
  'err.commentEmpty': 'Scrie un comentariu',
  'billing.fHistory': 'Istoric versiuni, comentarii, aprobarea șabloanelor, jurnal de activitate',
  'brand.title': 'Kit de brand',
  'brand.description':
    'Culorile, fonturile și siglele brandului se setează o dată — șabloanele le folosesc prin referință.',
  'brand.create': 'Creează un brand',
  'brand.newName': 'Brand {n}',
  'brand.paid':
    'Kitul de brand este în Pro (un brand) și Business (mai multe branduri, comutare între brandurile clienților în automatizări și API).',
  'brand.emptyTitle': 'Încă nu sunt branduri',
  'brand.emptyText': 'Creează un brand și setează-i culorile, fonturile și siglele.',
  'brand.moreOnBusiness': 'Mai multe branduri (pentru agenții și clienți) — în planul Business.',
  'brand.default': 'Implicit',
  'brand.makeDefault': 'Setează implicit',
  'brand.saved': 'Brand salvat — șabloanele se actualizează',
  'brand.colorsTitle': 'Culori',
  'brand.fontsTitle': 'Fonturi',
  'brand.logosTitle': 'Sigle',
  'brand.deleteTitle': 'Ștergi brandul „{name}”?',
  'brand.deleteText':
    'Șabloanele care îl folosesc vor lua brandul implicit sau valorile de rezervă.',
  'brand.howTitle': 'Cum funcționează',
  'brand.howText':
    'În editor alege o culoare, un font sau o siglă din secțiunea brandului — stratul reține referința la slot („Principală”, „Titluri”, „Siglă”), nu valoarea. Schimbă brandul și toate șabloanele se actualizează. Toate brandurile au aceleași sloturi, deci un set de șabloane funcționează pentru orice client: alege brandul în automatizare sau trimite brand_id în API.',
  'brand.colors': 'Culorile brandului „{name}”',
  'brand.fonts': 'Fonturile brandului „{name}”',
  'brand.logos': 'Siglele brandului „{name}”',
  'brand.detach': 'Detașează de brand (păstrează culoarea curentă)',
  'brand.useDefault': 'Brandul implicit ({name})',
  'brand.templateHint':
    'Brandul cu care șablonul este afișat și randat, dacă automatizarea sau API-ul nu aleg altul.',
  'brand.editorHint':
    'Setează o dată culorile, fonturile și siglele brandului și folosește-le în toate șabloanele.',
  'brand.automationLabel': 'Brand',
  'brand.automationHint':
    'Culorile, fonturile și siglele brandului pentru toate bannerele rulării.',
  'brand.templateBrand': 'Brandul fiecărui șablon',
  'brand.slot.primary': 'Principală',
  'brand.slot.secondary': 'Secundară',
  'brand.slot.accent': 'Accent',
  'brand.slot.background': 'Fundal',
  'brand.slot.text': 'Text',
  'brand.slot.font-heading': 'Titluri',
  'brand.slot.font-body': 'Text de bază',
  'brand.slot.logo': 'Siglă',
  'brand.slot.logo-light': 'Siglă deschisă',
  'brand.slot.logo-icon': 'Pictogramă',
  'err.brandsPlan': 'Kitul de brand este disponibil în Pro și Business',
  'err.brandsLimit': 'Planul tău permite {limit} branduri',
  'err.brandInvalid': 'Verifică valorile brandului',
  'billing.fBrands': 'Kit de brand',
  'landing.brandDemoTitle': 'Colecție nouă',
  'landing.brandDemoSub': 'Doar până duminică',
  'landing.brandsTitle': 'Un singur set de șabloane — brandurile tuturor clienților',
  'landing.brandsSubtitle':
    'Setează o dată culorile, fonturile și siglele brandului. Șabloanele folosesc kitul de brand: schimbi culoarea și toate bannerele se actualizează. Comuți brandul clientului în automatizare sau cu un parametru API.',
  'landing.brandsP1Title': 'Kit de brand',
  'landing.brandsP1Text':
    'Culori, fonturi, sigle. Un brand în Pro, oricâte în Business — comutate din mers.',
  'landing.brandsP2Title': 'Istoric versiuni cu revenire',
  'landing.brandsP2Text':
    'Fiecare sesiune de editare este salvată. Ai stricat un șablon înainte de lansare? Revii la versiunea anterioară cu un clic.',
  'landing.brandsP3Title': 'Comentarii și aprobări',
  'landing.brandsP3Text':
    'Note direct pe stratul șablonului, stări „în aprobare” și „aprobat”. API-ul și campaniile desenează doar versiunea aprobată — modificările nu ajung în producție fără aprobare.',
  'landing.brandsP4Title': 'Jurnal de activitate',
  'landing.brandsP4Text':
    'Cine a modificat un șablon, cine a rulat o automatizare și cu ce cheie API — totul e acolo.',
  'landing.brandsDemoLabel': 'Un șablon · trei branduri',
  'landing.brandsDemoHint':
    'Este o randare live: același șablon, kituri de brand diferite — culori, fonturi, accente.',
  'landing.f7Title': 'Bibliotecă media cu dosare',
  'landing.f7Text':
    'Sigle de echipe, poze de produse, fundaluri — în dosare, cu căutare. În tabel scrii media:Echipe/Arsenal și se folosește fișierul potrivit.',
  'landing.f8Title': 'Coduri QR în stilul brandului',
  'landing.f8Text':
    'Puncte rotunjite sau cercuri, colțuri stilizate colorate, logo în centru — și se scanează în continuare.',
  'landing.f9Title': 'Tabelul se potrivește singur',
  'landing.f9Text':
    'Încarci un CSV sau alegi un Google Sheet din listă — coloanele se potrivesc singure cu straturile: „Titlu”, „Home Logo”, „Preț”.',
  'landing.q7': 'Pot gestiona mai mulți clienți cu branduri diferite?',
  'landing.a7':
    'Da. În Business creezi un kit de brand pentru fiecare client — culori, fonturi, sigle. Șabloanele folosesc brandul, deci același set merge pentru toți: alegi brandul în automatizare sau trimiți brand_id în API.',
  'landing.q8': 'Ce se întâmplă dacă cineva strică un șablon?',
  'landing.a8':
    'În Business fiecare sesiune de editare ajunge în istoricul versiunilor: îl deschizi, vezi previzualizarea și restaurezi orice versiune cu un clic. Jurnalul de activitate arată cine și când a modificat șablonul.',
  'editor.tabBrand': 'Brand',
  'brandPanel.empty':
    'Încă nu există un brand kit. Adaugă culori, fonturi și logouri și aplică-le dintr-un clic.',
  'brandPanel.toSelection': 'straturilor selectate ({n})',
  'brandPanel.toBackground': 'fundalului',
  'brandPanel.linked': 'Legate de brand: {n}',
  'brandPanel.nothingToLink': 'Nicio culoare sau font din șablon nu se potrivește cu brandul',
  'brandPanel.edit': 'Editează brand kitul',
  'brandPanel.clickHint': 'Clic pe o culoare o aplică {target}. Valoarea rămâne legată de brand.',
  'brandPanel.fontHint':
    'Clic pentru a aplica textului selectat sau a adăuga text nou cu acest font',
  'brandPanel.logoHint': 'Clic pentru a înlocui imaginea selectată sau a adăuga logoul',
  'brandPanel.linkAll': 'Leagă șablonul de brand',
  'brandPanel.linkAllHint':
    'Găsește în șablon culorile, fonturile și logourile brandului și le leagă, astfel încât alt brand restilizează tot bannerul.',
  'brandImport.open': 'Importă',
  'brandImport.title': 'Importă un brand kit',
  'brandImport.description':
    'Colectăm culori, fonturi și logouri de pe un site sau dintr-un fișier Figma.',
  'brandImport.reviewHint': 'Verifică ce am găsit și ajustează dacă e nevoie.',
  'brandImport.back': 'Înapoi',
  'brandImport.replace': 'Actualizează brandul',
  'brandImport.create': 'Creează brandul',
  'brandImport.website': 'Site',
  'brandImport.siteLabel': 'Adresa site-ului',
  'brandImport.siteHint': 'Preluăm culorile din CSS, fonturile și logoul de pe pagina principală.',
  'brandImport.find': 'Caută',
  'brandImport.figmaConnect': 'Conectează Figma pentru a citi stilurile și variabilele fișierului.',
  'brandImport.figmaStep1':
    'În Figma: Settings → Security → Personal access tokens → Generate new token (citire fișiere).',
  'brandImport.figmaStep2': 'Lipește tokenul mai jos. Este stocat criptat.',
  'brandImport.connect': 'Conectează',
  'brandImport.figmaLabel': 'Link către fișierul Figma',
  'brandImport.figmaHint':
    'Cel mai bine un fișier design system: stiluri de culoare și text, logouri ca componente.',
  'brandImport.reading': 'Citim sursa…',
  'brandImport.name': 'Numele brandului',
  'brandImport.saveTo': 'Salvează ca',
  'brandImport.newBrand': 'Brand nou',
  'brandImport.replaceBrand': 'Înlocuiește „{name}”',
  'brandImport.pickFor': 'Alege o culoare',
  'brandImport.paletteHint': 'Paleta găsită: clic pentru a atribui culoarea slotului selectat',
  'brandImport.fontMissing':
    'Fontul „{family}” nu e în bibliotecă: alege unul similar sau încarcă fișierul.',
  'brandImport.noLogos': 'Nu am găsit logouri. Le poți adăuga mai târziu.',
  'brandImport.skipLogo': 'Nu importa',
  'brandImport.saved': 'Brand kit importat',
  'integrations.figmaHint': 'Importă brand kituri din stilurile și variabilele fișierelor Figma.',
  'err.siteHttp': 'Site-ul a răspuns cu HTTP {status}.',
  'err.figmaLink': 'Nu pare un link către un fișier Figma.',
  'err.figmaToken': 'Lipește un token Figma.',
  'err.figmaNotFound': 'Fișierul Figma nu a fost găsit. Verifică linkul.',
  'err.figmaForbidden': 'Fără acces: tokenul e invalid sau contul nu poate deschide fișierul.',
  'err.figmaError': 'Figma a returnat o eroare. Încearcă mai târziu.',
  'brandDs.onPage': 'Pe pagină',
  'brandDs.overview': 'Prezentare',
  'brandDs.typography': 'Tipografie',
  'brandDs.usage': 'În practică',
  'brandDs.tagline': 'Culorile, fonturile și logourile brandului în fiecare banner',
  'brandDs.colorsHint':
    'Clic pe mostră pentru a alege culoarea sau scrie HEX. Șabloanele folosesc slotul (tokenul), nu valoarea, deci schimbarea culorii restilizează toate bannerele.',
  'brandDs.notSet': 'Nesetat',
  'brandDs.contrast': 'Contrastul perechilor',
  'brandDs.contrastHint': 'Lizibilitate WCAG: AA de la 4.5, AAA de la 7, 3+ doar pentru text mare.',
  'brandDs.pairSample': 'Reduceri −30%',
  'brandDs.largeOnly': 'mare',
  'brandDs.fail': 'slab',
  'brandDs.typeHint':
    'Fonturile pentru titluri și text. Straturile cu fontul brandului se schimbă odată cu brand kitul.',
  'brandDs.sampleHeadline': 'Un banner îndrăzneț în câteva secunde',
  'brandDs.sampleBody':
    'Șabloanele preiau culorile, fonturile și logourile din brand kit, deci fiecare randare arată ca brandul.',
  'brandDs.logosHint':
    'Logoul principal pentru fundal deschis, cel deschis pentru fundal închis (pe culoarea principală), iconița pentru formate mici.',
  'brandDs.usageHint':
    'Așa arată șabloanele legate de brand cu acest kit. Previzualizarea include imediat modificările nesalvate.',
  'brandDs.sampleCta': 'Cumpără',
  'brandDs.unsaved': 'Ai modificări nesalvate',
  'brandDs.discard': 'Renunță',
  'keys.title': 'Comenzi rapide',
  'keys.description':
    'Funcționează când pânza are focus. Tastele cu litere merg în orice aranjament.',
  'keys.general': 'General',
  'keys.layers': 'Straturi',
  'keys.animation': 'Animație',
  'keys.playPause': 'Redare / pauză',
  'keys.frameStep': 'Cadru înapoi / înainte',
  'keys.secondStep': 'Secundă înapoi / înainte',
  'keys.toStartEnd': 'La început / sfârșit',
  'keys.view': 'Vizualizare',
  'keys.tools': 'Instrumente',
  'keys.save': 'Salvează',
  'keys.cut': 'Taie',
  'keys.selectAll': 'Selectează tot',
  'keys.delete': 'Șterge',
  'keys.deselect': 'Deselectează / ieși din stivă',
  'keys.editText': 'Editează textul',
  'keys.dblclick': 'dublu clic',
  'keys.cheatsheet': 'Această fișă',
  'editor.panelLeft': 'panoul de straturi',
  'editor.panelRight': 'panoul de proprietăți',
  'editor.panelBottom': 'cronologia și storyboard-ul',
  'editor.panelShow': 'Afișează {panel}',
  'editor.panelHide': 'Restrânge {panel}',
  'editor.focus': 'Accent pe previzualizare: restrânge toate panourile',
  'editor.focusExit': 'Readu panourile',
  'editor.panels': 'Panouri',
  'editor.timelineResize': 'Trageți pentru a schimba înălțimea',
  'keys.nudge': 'Mută 1 px',
  'keys.nudge10': 'Mută 10 px',
  'keys.forward': 'Adu în față',
  'keys.backward': 'Trimite în spate',
  'keys.front': 'Adu în prim-plan',
  'keys.back': 'Trimite în fundal',
  'keys.hideShow': 'Ascunde / arată',
  'keys.lockUnlock': 'Blochează / deblochează',
  'keys.keepRatio': 'Păstrează proporțiile',
  'keys.rotateStep': 'Rotire în pași de 15°',
  'keys.distances': 'Distanțe până la vecini',
  'keys.drag': 'trage',
  'keys.rotate': 'rotește',
  'keys.wheel': 'rotiță',
  'keys.zoomWheel': 'Zoom la cursor',
  'keys.pan': 'Deplasează pânza',
  'keys.select': 'Selectare',
  'keys.body': 'Text',
  'plan.from': 'Disponibil de la planul {plan}',
  'templates.placidFonts':
    'Nu am putut descărca fonturile: {fonts}. Straturile le folosesc deja; încarcă fișierele în secțiunea Fonturi.',
  'templates.placidImages': '{n} imagini au rămas legate de Placid: nu au putut fi descărcate.',
  'templates.placidSkipped': 'Elemente neacceptate omise: {types}',
  'templates.badJson': 'Fișierul nu este JSON valid',
  'err.placidFormat': 'Fișierul nu pare un export de șablon Placid',
  'consent.title': 'Folosim cookie-uri',
  'consent.text':
    'Cookie-urile esențiale te păstrează autentificat. Cu acordul tău folosim și Google Analytics ca să îmbunătățim serviciul. Fără cookie-uri publicitare.',
  'consent.accept': 'Accept toate',
  'consent.essentialOnly': 'Doar esențiale',
  'consent.customize': 'Personalizează',
  'consent.save': 'Salvează alegerea',
  'consent.settingsTitle': 'Setări cookie',
  'consent.settingsText':
    'Alege ce permiți. Poți schimba oricând din subsolul site-ului sau din profil.',
  'consent.essential': 'Esențiale',
  'consent.essentialText':
    'Sesiunea de autentificare, protecția cererilor, limba și spațiul ales. Serviciul nu funcționează fără ele.',
  'consent.always': 'Mereu active',
  'consent.analytics': 'Analiză (Google Analytics)',
  'consent.analyticsText':
    'Statistici pseudonime ale vizitelor: ce pagini se deschid și de unde vin vizitatorii. Cookie-urile _ga durează până la 2 ani; Google păstrează datele 14 luni.',
  'consent.more': 'Detalii în',
  'consent.link': 'Setări cookie',
  'privacy.title': 'Confidențialitate și date',
  'privacy.text': 'Descarcă o copie a datelor, schimbă setările cookie sau șterge contul.',
  'privacy.export': 'Descarcă datele mele',
  'privacy.delete': 'Șterge contul',
  'privacy.deleteTitle': 'Ștergi contul definitiv?',
  'privacy.deleteText':
    'Contul, datele tale și spațiile folosite doar de tine (cu șabloane și fișiere) vor fi șterse definitiv. Poți descărca mai întâi o copie a datelor.',
  'privacy.deleteConfirm': 'Șterge definitiv',
  'privacy.blocked': 'Rezolvă mai întâi aceste spații:',
  'privacy.blocker.transferOwnership':
    'ești singurul proprietar și are membri: numește alt proprietar',
  'privacy.blocker.cancelSubscription': 'abonament activ: anulează-l din Plan și plată',
  'privacy.willDelete': 'Spații care vor fi șterse:',
  'privacy.willLeave': 'Vei părăsi:',
  'privacy.typeEmail': 'Scrie {email} pentru confirmare',
  'err.confirmEmail': 'Scrie emailul pentru confirmare',
  'brandDs.sampleQuote':
    'Am lansat 300 de bannere pentru reduceri într-o seară, toate în stilul nostru.',
  'brandDs.sampleAuthor': 'Anna Koval',
  'brandDs.sampleRole': 'Director artistic',
  'brandDs.sampleDate': '24 mai',
  'brandDs.samplePlace': 'Online · 19:00',
  'brandDs.sampleNew': 'Nou',
  'preview.fake': 'Date aleatorii',
  'preview.fakeRun': 'Aleatoriu + randare',
  'preview.fakeHint':
    'Textele se aleg după numele stratului (price, date, team, title…); fotografiile sunt imagini Unsplash gratuite prin Lorem Picsum, logourile de la DiceBear.',
  'gallery.cat.sport': 'Meciuri și turnee',
  'fonts.cat.all': 'Toate',
  'fonts.cat.sans-serif': 'Sans',
  'fonts.cat.serif': 'Serif',
  'fonts.cat.display': 'Display',
  'fonts.cat.handwriting': 'De mână',
  'fonts.cat.monospace': 'Mono',
  'stock.myFiles': 'Fișierele mele',
  'stock.photos': 'Fotografii Unsplash',
  'stock.search': 'Caută fotografii gratuite (mai bine în engleză)',
  'stock.more': 'Mai multe fotografii',
  'stock.error': 'Nu am putut încărca fotografiile. Încearcă mai târziu.',
  'stock.credit':
    'Fotografii gratuite pentru uz comercial; autorul e menționat în descrierea stratului. Sursa:',
  'stock.idea.coffee': 'coffee',
  'stock.idea.city': 'city night',
  'stock.idea.sport': 'football stadium',
  'stock.idea.food': 'food flat lay',
  'stock.idea.nature': 'mountains',
  'stock.idea.people': 'smiling woman',
  'err.stockOff': 'Căutarea foto nu e configurată',
  'err.stockLimit': 'Limita Unsplash a fost atinsă, încearcă mai târziu',
  'err.stockError': 'Unsplash a returnat o eroare',
  'motion.mode': 'Animație',
  'motion.modeHint': 'Animează șablonul pentru video, GIF și bannere animate',
  'motion.back': 'Înapoi la design',
  'motion.tabDesign': 'Design',
  'motion.tabDesignHint':
    'Textul, fontul, culorile și dimensiunea stratului — direct în animație. Dublu clic pe un text pe scenă pentru a-l edita pe loc',
  'motion.tabMotion': 'Animație',
  'motion.sceneGraphics': 'Grafică animată a scenei',
  'motion.sceneGraphicsHint': 'Deschide în animație pentru a edita textul și setările',
  'motion.play': 'Redă',
  'motion.pause': 'Pauză',
  'motion.animate': 'Animează',
  'motion.animateHint':
    'Animează toate straturile în stilul ales. Setările manuale vor fi înlocuite.',
  'motion.style': 'Stil de mișcare',
  'motion.clear': 'Elimină animația',
  'motion.empty':
    'Șablonul este static deocamdată. Alege un stil și apasă „Animează” sau setează fiecare strat.',
  'motion.video': 'Video',
  'motion.duration': 'Durată',
  'motion.fps': 'Cadre/s',
  'motion.loops': 'Repetări banner',
  'motion.forever': 'La infinit',
  'motion.scenes': 'Scene',
  'motion.scenesHint':
    'Scenele rulează pe rând, ca ramele unui banner HTML5. Straturile fără scenă rămân pe ecran.',
  'motion.addScene': 'Adaugă scenă',
  'motion.sceneN': 'Scena {n}',
  'motion.transition': 'Tranziție',
  'motion.none': 'Niciuna',
  'motion.enter': 'Intrare',
  'motion.emphasis': 'Accent',
  'motion.exit': 'Ieșire',
  'motion.delay': 'Întârziere',
  'motion.beforeEnd': 'Înainte de final',
  'motion.length': 'Lungime',
  'motion.easing': 'Curbă',
  'motion.easingDefault': 'Ca în preset',
  'motion.repeat': 'Repetări',
  'motion.repeatHint': '0 = până la finalul scenei',
  'motion.gap': 'Pauză',
  'motion.split': 'Text pe bucăți',
  'motion.split_none': 'Întreg',
  'motion.split_line': 'Rânduri',
  'motion.split_word': 'Cuvinte',
  'motion.split_char': 'Litere',
  'motion.stagger': 'Decalaj',
  'motion.order': 'Ordine',
  'motion.order_start': 'De la început',
  'motion.order_end': 'De la final',
  'motion.order_center': 'Din centru',
  'motion.order_edges': 'De la margini',
  'motion.order_random': 'Aleatoriu',
  'motion.scene': 'Scenă',
  'motion.wholeVideo': 'Tot videoclipul',
  'motion.layerHint': 'Selectează un strat din listă sau din cronologie pentru a-i seta mișcarea.',
  'motion.dir_up': 'Sus',
  'motion.dir_down': 'Jos',
  'motion.dir_left': 'Stânga',
  'motion.dir_right': 'Dreapta',
  'motion.sec': 's',
  'motion.opener': 'Început',
  'motion.layerStyle': 'Mișcarea straturilor',
  'motion.noOpener': 'Fără deschidere',
  'motion.pickHint':
    'Deschiderea, mișcarea straturilor, accentele și finalul se completează; alegerea se aplică imediat.',
  'motion.openerPickHint':
    'Grafică la începutul clipului, peste design. Treceți cu mouse-ul pentru redare.',
  'motion.stylePickHint': 'Cum intră și se mișcă straturile. Treceți cu mouse-ul pentru redare.',
  'motion.outro': 'Final',
  'motion.noOutro': 'Fără final',
  'motion.outroPickHint':
    'Cum se termină clipul: cartelă cu îndemn, accent pe ofertă, buclă. Treceți cu mouse-ul pentru redare.',
  'motion.accents': 'Accente',
  'motion.accentsHint':
    'Momente în mijlocul clipului, legate de elemente. Fără elementul său, accentul nu face nimic.',
  'motion.customBadge': 'Al tău',
  'motion.deletePresetTitle': 'Ștergeți presetul?',
  'motion.deletePresetText':
    'Presetul dispare din liste. Șabloanele animate deja cu el rămân la fel: au propria copie.',
  'motion.soundBarHint':
    'Trageți pentru a muta; marginile taie începutul și sfârșitul; cu Shift sunetul alunecă în segment; Alt ignoră bătăile',
  'motion.splitSound': 'Taie',
  'motion.splitSoundHint': 'Taie sunetul la cursor (S)',
  'motion.splitSoundOutside': 'Puneți cursorul în interiorul sunetului ales',
  'motion.removeSound': 'Șterge sunetul',
  'motion.oneScene': 'una',
  'admin.settings': 'Setări',
  'admin.settingsSaved': 'Salvat',
  'backup.tab': 'Mutarea serverului',
  'backup.exportTitle': 'Descarcă o copie de rezervă',
  'backup.exportText':
    'Un ZIP cu toată baza de date (utilizatori, spații, șabloane, automatizări, integrări, istoric) și toate fișierele. Încarcă-l în panoul de administrare al noului server.',
  'backup.includeFiles': 'Cu fișiere (debifează dacă ambele servere folosesc același S3)',
  'backup.download': 'Descarcă copia',
  'backup.importTitle': 'Restaurează dintr-o copie',
  'backup.importText':
    'Înlocuiește toate datele acestui server cu cele din copie. Versiunea Bannermatic și ENCRYPTION_KEY trebuie să fie ca pe serverul vechi. Conturile și sesiunile se mută împreună cu baza.',
  'backup.chooseFile': 'Alege ZIP-ul',
  'backup.restore': 'Restaurează',
  'backup.confirmTitle': 'Înlocuiești toate datele acestui server?',
  'backup.confirmText':
    'Toți utilizatorii, șabloanele și setările de aici vor fi înlocuite cu cele din copie. Acțiunea nu poate fi anulată.',
  'backup.keyHint':
    'ENCRYPTION_KEY diferă aici: conturile Google conectate, S3 și alte secrete nu se vor deschide. Mai bine copiază ENCRYPTION_KEY de pe serverul vechi și repornește-l pe acesta.',
  'backup.ignoreKey': 'Restaurează oricum (integrările trebuie reconectate)',
  'backup.restored':
    'Restaurat: {users} utilizatori, {files} fișiere. Dacă ți se cere autentificarea, folosește contul de pe serverul vechi.',
  'err.backupInvalid': 'Aceasta nu este o copie Bannermatic.',
  'err.backupVersion':
    'Copia provine din altă versiune Bannermatic. Actualizează mai întâi ambele servere la aceeași versiune.',
  'err.backupKey': 'ENCRYPTION_KEY diferă de serverul vechi.',
  'admin.serverVideo': 'Randarea video pe server',
  'admin.serverVideoPlans': 'Planuri care pot randa video pe server',
  'admin.serverVideoPlansHint':
    'Celelalte planuri randează video doar în browserul utilizatorului, chiar dacă randarea pe server este activă.',
  'admin.serverVideoOffHint':
    'Oprit pentru toți. Videoclipurile (MP4, WebM, GIF) se randează doar pe calculatorul utilizatorului, în editor. API-ul și automatizările cu formate video primesc o eroare; imaginile funcționează normal.',
  'admin.serverVideoOnHint':
    'Pornit pentru toți. Videoclipurile se randează pe serverele tale: din editor, API și automatizări. Un clip de 5 s 1080×1080 ia circa 20 vCPU·s.',
  'browserRender.serverOffNoDevice':
    'Deocamdată videoclipurile se randează doar pe calculatorul utilizatorului, iar acest browser nu poate. Deschide editorul în Chrome sau Edge pe un calculator.',
  'automation.serverVideoOff':
    'Formatele video nu sunt disponibile: randarea video pe server este oprită deocamdată. Fă videoclipuri în editor, cu butonul „Generează”.',
  'err.serverVideoOff':
    'Randarea video pe server este oprită. Fă videoclipul în editor: „Generează” → pe acest calculator.',
  'resize.videoFormats': 'Formate pentru rețele sociale',
  'motion.easingHint':
    'Cum se schimbă viteza mișcării: pe orizontală timpul, pe verticală distanța. Treci cu mouse-ul ca să vezi.',
  'video.galleryHint':
    'Videoclipuri publicitare gata făcute, cu scene, tranziții și montaj. Treci cu mouse-ul peste card ca să-l vezi, alege formatul și înlocuiește fotografiile și textele.',
  'video.hoverToPlay': 'Treci cu mouse-ul pentru redare',
  'video.cat.basic': 'Structuri de bază',
  'video.cat.sale': 'Reduceri',
  'video.cat.product': 'Produs',
  'video.cat.fashion': 'Modă',
  'video.cat.food': 'Mâncare',
  'video.cat.realestate': 'Imobiliare',
  'video.cat.travel': 'Călătorii',
  'video.cat.fitness': 'Fitness',
  'video.cat.event': 'Evenimente',
  'video.cat.tech': 'Aplicații și IT',
  'video.cat.beauty': 'Frumusețe',
  'video.cat.auto': 'Auto',
  'video.cat.hiring': 'Angajări',
  'video.cat.holiday': 'Sărbători',
  'video.cat.social': 'Social și recenzii',
  'video.cat.motion': 'Motion design',
  'api.videoHelp':
    'videoclipuri și șabloane animate (randarea durează mai mult: folosește ?wait=false și webhook_url). Un strat foto acceptă un link .mp4/.mov/.webm pentru un clip; tăiere: video_start, video_end (s), video_speed, video_muted.',
  'api.motionStyleHelp':
    'animează șablonul cu un stil (smooth, energetic, elegant, kinetic, sale…); fără el se folosește animația șablonului.',
  'api.soundHelp':
    'muzica și vocea videoclipului: link la fișier, null pentru a elimina sau { url, volume, start, fade_out }.',
  'automation.videoFormatsHint':
    'MP4, WEBM și GIF randează videoclipuri și animații. Un șablon static primește automat o animație lină.',
  'motion.zoom': 'Zoom cronologie',
  'motion.zoomIn': 'Mărește',
  'motion.zoomOut': 'Micșorează',
  'motion.zoomFit': 'Tot videoclipul',
  'motion.zoomHint': 'Zoom: Ctrl + rotița mouse-ului. Derulare laterală: Shift + rotița',
  'templates.filterBanners': 'Bannere',
  'templates.filterVideos': 'Videoclipuri',
  'templates.kindVideo': 'Videoclip',
  'templates.kindAnimated': 'Animat',
  'templates.scenes': 'scene: {n}',
  'story.openHint': 'Clic: mergi la scenă. Dublu clic sau creionul: deschide-o în design',
  'story.editDesign': 'Editează designul scenei',
  'sound.micInsecure':
    'Browserul oferă microfonul doar site-urilor https sau localhost. Deschide editorul prin https.',
  'sound.micMissing': 'Nu s-a găsit niciun microfon. Conectează-l și încearcă din nou.',
  'video.new': 'Videoclip nou',
  'video.fmt.vertical': 'Reels, TikTok, Shorts',
  'video.fmt.portrait': 'Feed, 4:5',
  'video.fmt.square': 'Pătrat',
  'video.fmt.wide': 'YouTube, site',
  'video.recipe.sale': 'Reduceri',
  'video.recipe.saleHint': 'Cârlig, produs, preț redus, îndemn',
  'video.recipe.launch': 'Lansare',
  'video.recipe.launchHint': 'Cârlig, produs, trei beneficii, îndemn',
  'video.recipe.review': 'Recenzie',
  'video.recipe.reviewHint': 'Citat de client, produs, beneficii, îndemn',
  'video.recipe.event': 'Eveniment',
  'video.recipe.eventHint': 'Cârlig, dată și loc, ce urmează, îndemn',
  'video.scene.hook': 'Cârlig',
  'video.scene.product': 'Produs',
  'video.scene.offer': 'Ofertă',
  'video.scene.benefits': 'Beneficii',
  'video.scene.quote': 'Recenzie',
  'video.scene.when': 'Când și unde',
  'video.scene.cta': 'Îndemn',
  'video.txt.hook.sale': 'Doar 3 zile!',
  'video.txt.hook.launch': 'Faceți cunoștință cu noutatea',
  'video.txt.hook.event': 'Nu rata!',
  'video.txt.product': 'Numele produsului',
  'video.txt.oldPrice': '299 lei',
  'video.txt.price': '149 lei',
  'video.txt.benefit1': 'Livrare gratuită',
  'video.txt.benefit2': 'Retur ușor',
  'video.txt.benefit3': 'Ales de peste 10.000 de clienți',
  'video.txt.quote': '„Cea mai bună achiziție a anului”',
  'video.txt.author': 'Ana, cumpărătoare',
  'video.txt.date': '12 iunie · 19:00',
  'video.txt.place': 'Online',
  'video.txt.cta.sale': 'Cumpără la reducere',
  'video.txt.cta.launch': 'Află mai multe',
  'video.txt.cta.review': 'Încearcă',
  'video.txt.cta.event': 'Înscrie-te',
  'safe.hint': 'Zone sigure: unde aplicația acoperă videoclipul cu butoane și text',
  'safe.off': 'Fără zone',
  'safe.zone': 'Zone {app}',
  'sound.title': 'Voce și sunete',
  'sound.record': 'Înregistrează vocea',
  'sound.stop': 'Stop',
  'sound.upload': 'Încarcă audio',
  'sound.hint':
    'Voce din off, efecte, o a doua melodie. Pornesc de la cursor, muzica scade sub voce.',
  'sound.recordingHint':
    'Se înregistrează odată cu videoclipul. Căștile ajută ca microfonul să nu prindă muzica.',
  'sound.micDenied':
    'Nu există acces la microfon. Apasă pe lacătul din stânga adresei site-ului, permite microfonul și încearcă din nou.',
  'sound.start': 'Început',
  'sound.here': 'La cursor',
  'sound.toPlayhead': 'Pornește de la cursor',
  'sound.duck': 'Muzica sub voce',
  'sound.kind.voice': 'Voce',
  'sound.kind.music': 'Muzică',
  'sound.kind.sfx': 'Efect',
  'editor.videoSpeed': 'Viteză',
  'editor.videoFitScene': 'Scena pe lungimea clipului ({s} s)',
  'story.title': 'Storyboard',
  'story.emptyHint': 'Împarte videoclipul în scene: cârlig, produs, beneficii, ofertă, îndemn.',
  'story.make': 'Împarte în scene',
  'story.add': 'Scenă',
  'story.split': 'Taie aici',
  'story.addAfter': 'Scenă nouă după aceasta',
  'story.moveEarlier': 'Mută mai devreme',
  'story.moveLater': 'Mută mai târziu',
  'story.cut': 'Tăietură',
  'story.toAll': 'Arată în toate scenele',
  'story.toScene': 'În toate scenele. Apasă pentru a o păstra doar în aceasta',
  'err.browserRenderPlan': 'Generarea pe propriul computer nu este disponibilă în acest plan.',
  'billing.fVideo': 'Video: {n} min pe lună ({m} min pe computerul tău)',
  'billing.videoPeriod': 'Video în perioada curentă',
  'billing.videoMin': '{n} min',
  'err.videoLimit':
    'Limita lunară de video a fost atinsă ({used} din {limit} s în planul {plan}). Generarea pe computerul tău consumă limita de 4 ori mai încet.',
  'browserRender.optionHint':
    'Videoclipul este desenat și codificat în browserul tău. Consumă de 4 ori mai puțin din limita de video decât generarea pe server.',
  'preview.deviceFree':
    'Mai ieftin: randarea pe computerul tău consumă de 4 ori mai puțin din limita de video.',
  'videoGen.title': 'Video din conținutul tău',
  'videoGen.hint': 'textele, pozele și brandul tău — de fiecare dată videoclipuri noi',
  'videoGen.headline': 'Titlu',
  'videoGen.brandName': 'Numele brandului sau produsului',
  'videoGen.subline': 'Subtitlu',
  'videoGen.benefits': 'Beneficii',
  'videoGen.perLine': 'Câte unul pe rând, până la 5',
  'videoGen.stats': 'Cifre',
  'videoGen.statsHint': '„12k — abonați”, câte una pe rând',
  'videoGen.more': 'Ofertă, preț, recenzie, buton',
  'videoGen.offer': 'Ofertă (−30%, 2 la 1)',
  'videoGen.offerNote': 'Notă la ofertă',
  'videoGen.price': 'Preț',
  'videoGen.oldPrice': 'Preț vechi',
  'videoGen.quote': 'Recenzie',
  'videoGen.author': 'Autorul recenziei',
  'videoGen.cta': 'Textul butonului',
  'videoGen.site': 'Site sau cont',
  'videoGen.brandKit': 'Kit de brand',
  'videoGen.brandKitHint': 'Culorile, fonturile și logoul brandului',
  'videoGen.noBrand': 'Fără brand — paletă aleatorie',
  'videoGen.logo': 'Logo',
  'videoGen.noLogo': 'Fără logo',
  'videoGen.logoBrand': 'Din kitul de brand',
  'videoGen.photos': 'Poze',
  'videoGen.photosHint': '{n} selectate · din bibliotecă sau încarcă-le pe ale tale',
  'videoGen.generate': 'Generează videoclipuri',
  'videoGen.again': 'Mai multe variante',
  'videoGen.needHeadline': 'E nevoie de un titlu',
  'videoGen.variant': 'varianta {n}',
  'browserRender.option': 'Pe acest computer (beta)',
  'browserRender.title': 'Generare pe acest computer',
  'browserRender.prepare': 'Pregătesc scena…',
  'browserRender.sound': 'Mixez sunetul…',
  'browserRender.frames': 'Cadrul {n} din {total}',
  'browserRender.paused': 'Pauză: fila este ascunsă. Revino la ea pentru a continua.',
  'browserRender.finish': 'Salvez videoclipul…',
  'browserRender.keepOpen': 'Nu închide și nu minimiza fila în timpul generării.',
  'browserRender.speed': 'Viteza depinde de computerul tău.',
  'browserRender.differs': 'Rezultatul poate diferi puțin de generarea pe server.',
  'browserRender.cancelled': 'Generare anulată',
  'motion.music': 'Muzică',
  'motion.noMusic': 'Fără muzică',
  'motion.musicUpload': 'Încarcă o piesă (MP3, M4A, WAV, OGG, FLAC)',
  'motion.musicHint':
    'Încarcă o piesă și îi găsim tempoul: „Animează” pune mișcările pe ritm, iar sunetul ajunge în MP4 și WEBM.',
  'motion.musicStart': 'Decalaj piesă',
  'motion.musicAt': 'Start',
  'motion.musicAtHint': 'Când începe muzica în clip',
  'motion.musicLength': 'Durată',
  'motion.musicLengthHint': 'Cât cântă muzica. Până la finalul clipului: crește odată cu clipul',
  'motion.bpmHint':
    'Tempoul piesei în bătăi pe minut. Găsit automat, se poate corecta; 0 oprește grila.',
  'motion.fadeIn': 'Apariție',
  'motion.fadeOut': 'Stingere',
  'motion.beatSync': '„Animează” pe ritmul muzicii',
  'motion.syncNow': 'Potrivește pe ritm',
  'motion.noBeat': 'Piesa nu are un ritm constant. Introdu BPM manual dacă există.',
  'err.audioUnreadable': 'Nu am putut citi sunetul: încarcă MP3, M4A, WAV, OGG sau FLAC.',
  'motion.beats': 'Bătăi',
  'motion.keys': 'Cadre cheie',
  'motion.keysHint':
    'Pune cursorul de timp și trage stratul pe scenă pentru a înregistra un cadru. Trage-l din nou în alt moment și stratul se mișcă între ele.',
  'motion.keyScale': 'Scară',
  'motion.keyRotate': 'Rotație',
  'motion.keyOpacity': 'Opacitate',
  'motion.keyEasing': 'Până la următorul',
  'motion.keyDelete': 'Șterge cadrul',
  'motion.keyAdd': 'Cadru aici',
  'motion.keysClear': 'Șterge toate',
  'motion.openers': 'Deschideri',
  'motion.styles': 'Stiluri de mișcare',
  'motion.fx': 'Grafică',
  'motion.fxHint':
    'Panouri, cercuri, confetti, titluri și fundaluri peste sau sub design. Culorile vin din șablon.',
  'motion.addFx': '+ Adaugă grafică',
  'motion.camera': 'Cameră',
  'motion.cameraHint': 'Mișcări ale întregii compoziții: apropiere, depărtare, scuturare.',
  'motion.addCamera': '+ Adaugă mișcare de cameră',
  'motion.start': 'Început',
  'motion.zLayer': 'Unde',
  'motion.zFront': 'Peste design',
  'motion.zBack': 'Sub straturi (fundal)',
  'motion.auto': 'Automat',
  'motion.color_accent': 'Accentul șablonului',
  'motion.color_accent2': 'Al doilea accent',
  'motion.color_dark': 'Închis',
  'motion.color_light': 'Deschis',
  'motion.color_ink': 'Contrast cu fundalul',
  'motion.color_custom': 'Culoare proprie',
  'motion.fxcat_text': 'Titluri',
  'motion.fxcat_cover': 'Acoperiri',
  'motion.fxcat_accent': 'Accente',
  'motion.fxcat_ambient': 'Fundaluri',
  'motion.keyBlur': 'Neclaritate',
  'sound.auto': 'Sonorizează automat',
  'sound.autoAgain': 'Repoziționează efectele',
  'sound.autoClear': 'Elimină efectele automate',
  'sound.autoHint':
    'Fâșâit cu 0,4 s înainte de tranziție, lovitură la tăietură, tic pentru fiecare literă care aterizează, tastare pentru terminal și altele. Sunetele tale rămân.',
  'sound.addSfx': 'Efect',
  'sound.generateMusic': 'Generează muzică',
  'sound.listen': 'Ascultă o variantă',
  'sound.anotherTake': 'Altă variantă',
  'sound.useTake': 'În video',
  'sound.bpmAuto': '0 — stilul alege tempoul',
  'sound.energy_calm': 'Calm',
  'sound.energy_normal': 'Normal',
  'sound.energy_high': 'Energic',
  'sound.generateMusicHint':
    'Fiecare variantă e o piesă nouă: tonalitate, groove, bas, melodie, intro, drop și pauză; cinelele cad pe tăieturile video. Fără drepturi de autor.',
  'motion.fontAuto': 'Ca stratul sau titlul',
  'motion.fontReset': 'Resetează fontul',
  'motion.textFx': 'Efect de text',
  'motion.textFxHint':
    'Efectul devine parte a acestui strat: același text, font și culoare, stratul doar se mișcă altfel. Bara lui e pe rândul stratului în cronologie.',
  'motion.textFxApply': 'Aplică',
  'motion.poster': 'Copertă (miniatură și imagine)',
  'motion.textFxUntilEnd': '0 — cât stratul e pe ecran',
  'motion.textFxRemove': 'Elimină efectul',
  'motion.generator': 'Generator de mișcare',
  'motion.generatorHint':
    'Traseele, fizica și zgomotul sunt scrise ca chei de la cursor, editabile una câte una.',
  'motion.genDistance': 'Amplitudine',
  'motion.genAngle': 'Unghi',
  'motion.genGrow': 'Creștere, %',
  'motion.genCycles': 'Cicluri',
  'motion.genLength': 'Durată',
  'motion.genDirection': 'Direcție',
  'motion.genOrient': 'Rotește de-a lungul traseului',
  'motion.genApply': 'Scrie cheile',
  'motion.repeater': 'Multiplică stratul',
  'motion.repeaterHint':
    'Copii în grilă, cerc, linie, spirală sau împrăștiate, fiecare pornind puțin mai târziu.',
  'motion.repeatLayout': 'Aranjare',
  'motion.repeat_grid': 'Grilă',
  'motion.repeat_circle': 'Cerc',
  'motion.repeat_line': 'Linie',
  'motion.repeat_spiral': 'Spirală',
  'motion.repeat_scatter': 'Împrăștiere',
  'motion.repeatCount': 'Câte',
  'motion.repeatCols': 'Pe rând',
  'motion.repeatRadius': 'Rază',
  'motion.repeatAngle': 'Unghi',
  'motion.repeatGap': 'Spațiu',
  'motion.repeatStagger': 'Decalaj',
  'motion.repeatRotate': 'Rotire',
  'motion.repeatScale': 'Mărime',
  'motion.repeatOpacity': 'Opacitate',
  'motion.repeatOrient': 'Orientează spre exterior',
  'motion.repeatApply': 'Creează copii ({n})',
  'motion.fxcat_interface': 'Interfață și date',
  'motion.fxcat_pattern': 'Modele și particule',
  'motion.cost': 'Videoclipurile durează mai mult decât imaginile, de obicei 10–30 de secunde.',
};
